export const mockListingsData = {
  silhouette: {
    name: 'Silhouette',
    slug: 'silhouette',
    sort: 1,
    children: [
      {
        name: 'Air Jordan',
        slug: 'silhouette/air-jordan',
        sort: 1,
        children: [
          {
            name: 'Air Jordan 4',
            slug: 'silhouette/air-jordan/air-jordan-4',
            sort: 1,
          },
        ],
      },
      {
        name: 'Air Jordan 5',
        slug: 'silhouette/air-jordan-5',
        sort: 2,
        description:
          '<p>CMS Description: <a href="http://localhost:5100/sneakers/designer/tinker-hatfield"><ins>Tinker Hatfield</ins></a> channeled Michael Jordan’s aerial combativeness in designing the Jordan Retro 5, adding shark-tooth detailing inspired by WWII fighter planes to the midsole. The shoe also featured a clear outsole, lace locks and &nbsp;a reflective tongue, allowing the sneaker to shine when hit with flash photography.</p>',
        metadataDescription:
          'The shoe also featured a clear outsole, lace locks and a reflective tongue, allowing the sneaker to shine when hit with flash photography.',
        coverAsset: {
          id: 3580899,
          url: 'https://cms-cdn-staging.foodsworth.com/fda67ba46c7e-7389-ae11-789e-06da2880.jpeg',
          aspect: 1.49700598802395,
          imageFileName: 'AJ5.jpeg',
          type: 'picture',
          thumbUrl:
            'https://cms-cdn-staging.foodsworth.com/375/fda67ba46c7e-7389-ae11-789e-06da2880.jpeg',
          smallUrl:
            'https://cms-cdn-staging.foodsworth.com/750/fda67ba46c7e-7389-ae11-789e-06da2880.jpeg',
          mediumUrl:
            'https://cms-cdn-staging.foodsworth.com/1500/fda67ba46c7e-7389-ae11-789e-06da2880.jpeg',
          largeUrl:
            'https://cms-cdn-staging.foodsworth.com/3000/fda67ba46c7e-7389-ae11-789e-06da2880.jpeg',
        },
        headerAsset: {
          id: 3462305,
          url: 'https://cms-cdn-staging.foodsworth.com/7a482b591271-9788-ae11-ddac-006cfe46',
          aspect: 1,
          imageFileName: 'airjordan.png',
          type: 'picture',
          thumbUrl:
            'https://cms-cdn-staging.foodsworth.com/375/7a482b591271-9788-ae11-ddac-006cfe46',
          smallUrl:
            'https://cms-cdn-staging.foodsworth.com/750/7a482b591271-9788-ae11-ddac-006cfe46',
          mediumUrl:
            'https://cms-cdn-staging.foodsworth.com/1500/7a482b591271-9788-ae11-ddac-006cfe46',
          largeUrl:
            'https://cms-cdn-staging.foodsworth.com/3000/7a482b591271-9788-ae11-ddac-006cfe46',
        },
      },
      {
        name: 'Air Jordan 4',
        slug: 'silhouette/air-jordan-4',
        sort: 3,
        description:
          '<p>CMS Description: The Jordan Retro 4 is the shoe that Michael Jordan wore when he drained ‘the shot’ during the 1989 NBA playoffs. The sneaker would cement its legacy in the Spike Lee film ‘Do the Right Thing,’ a moment in history that signaled the growing cultural currency of the Air Jordan franchise.</p>',
        metadataDescription:
          'The Jordan Retro 4 is the shoe that Michael Jordan wore when he drained ‘the shot’ during the 1989 NBA playoffs.',
        coverAsset: {
          id: 3462305,
          url: 'https://cms-cdn-staging.foodsworth.com/7a482b591271-9788-ae11-ddac-006cfe46',
          aspect: 1,
          imageFileName: 'airjordan.png',
          type: 'picture',
          thumbUrl:
            'https://cms-cdn-staging.foodsworth.com/375/7a482b591271-9788-ae11-ddac-006cfe46',
          smallUrl:
            'https://cms-cdn-staging.foodsworth.com/750/7a482b591271-9788-ae11-ddac-006cfe46',
          mediumUrl:
            'https://cms-cdn-staging.foodsworth.com/1500/7a482b591271-9788-ae11-ddac-006cfe46',
          largeUrl:
            'https://cms-cdn-staging.foodsworth.com/3000/7a482b591271-9788-ae11-ddac-006cfe46',
        },
        headerAsset: {
          id: 3462305,
          url: 'https://cms-cdn-staging.foodsworth.com/7a482b591271-9788-ae11-ddac-006cfe46',
          aspect: 1,
          imageFileName: 'airjordan.png',
          type: 'picture',
          thumbUrl:
            'https://cms-cdn-staging.foodsworth.com/375/7a482b591271-9788-ae11-ddac-006cfe46',
          smallUrl:
            'https://cms-cdn-staging.foodsworth.com/750/7a482b591271-9788-ae11-ddac-006cfe46',
          mediumUrl:
            'https://cms-cdn-staging.foodsworth.com/1500/7a482b591271-9788-ae11-ddac-006cfe46',
          largeUrl:
            'https://cms-cdn-staging.foodsworth.com/3000/7a482b591271-9788-ae11-ddac-006cfe46',
        },
      },
      {
        name: 'Air Max 97',
        slug: 'silhouette/air-max-97',
        sort: 4,
        description:
          '<p>CMS Description: The Nike Air Max 97 may have debuted full-length Air cushioning, but the design of the upper was just as revolutionary. Designer Christian Tresser took inspiration from the concentric lines caused by a single drop of water, while the sneaker’s iconic <a href="http://localhost:5100/sneakers/air-max-97-silver-bullet-884421-001"><ins>‘Silver Bullet’</ins></a> colorway gave the nod to ‘90s mountain bikes.</p>',
        metadataDescription:
          'The Nike Air Max 97 may have debuted full-length Air cushioning, but the design of the upper was just as revolutionary. ',
      },
      {
        name: 'Air Jordan 3',
        slug: 'silhouette/air-jordan-3',
        sort: 5,
        metadataDescription: 'Meta content',
        coverAsset: {
          id: 3580901,
          url: 'https://cms-cdn-staging.foodsworth.com/fda67ba46c7e-7389-ae11-789e-02cd5780.jpeg',
          aspect: 1.68918918918919,
          imageFileName: 'AJ3.jpeg',
          type: 'picture',
          thumbUrl:
            'https://cms-cdn-staging.foodsworth.com/375/fda67ba46c7e-7389-ae11-789e-02cd5780.jpeg',
          smallUrl:
            'https://cms-cdn-staging.foodsworth.com/750/fda67ba46c7e-7389-ae11-789e-02cd5780.jpeg',
          mediumUrl:
            'https://cms-cdn-staging.foodsworth.com/1500/fda67ba46c7e-7389-ae11-789e-02cd5780.jpeg',
          largeUrl:
            'https://cms-cdn-staging.foodsworth.com/3000/fda67ba46c7e-7389-ae11-789e-02cd5780.jpeg',
        },
        headerAsset: {
          id: 3462305,
          url: 'https://cms-cdn-staging.foodsworth.com/7a482b591271-9788-ae11-ddac-006cfe46',
          aspect: 1,
          imageFileName: 'airjordan.png',
          type: 'picture',
          thumbUrl:
            'https://cms-cdn-staging.foodsworth.com/375/7a482b591271-9788-ae11-ddac-006cfe46',
          smallUrl:
            'https://cms-cdn-staging.foodsworth.com/750/7a482b591271-9788-ae11-ddac-006cfe46',
          mediumUrl:
            'https://cms-cdn-staging.foodsworth.com/1500/7a482b591271-9788-ae11-ddac-006cfe46',
          largeUrl:
            'https://cms-cdn-staging.foodsworth.com/3000/7a482b591271-9788-ae11-ddac-006cfe46',
        },
      },
      {
        name: 'Air Jordan 2',
        slug: 'silhouette/air-jordan-2',
        sort: 6,
        description: '<p>A <em>description</em> can say a lot of <strong>things</strong></p>',
        metadataDescription: 'Meta descriptions can also say a lot of thing',
        coverAsset: {
          id: 3462305,
          url: 'https://cms-cdn-staging.foodsworth.com/7a482b591271-9788-ae11-ddac-006cfe46',
          aspect: 1,
          imageFileName: 'airjordan.png',
          type: 'picture',
          thumbUrl:
            'https://cms-cdn-staging.foodsworth.com/375/7a482b591271-9788-ae11-ddac-006cfe46',
          smallUrl:
            'https://cms-cdn-staging.foodsworth.com/750/7a482b591271-9788-ae11-ddac-006cfe46',
          mediumUrl:
            'https://cms-cdn-staging.foodsworth.com/1500/7a482b591271-9788-ae11-ddac-006cfe46',
          largeUrl:
            'https://cms-cdn-staging.foodsworth.com/3000/7a482b591271-9788-ae11-ddac-006cfe46',
        },
        headerAsset: {
          id: 3462305,
          url: 'https://cms-cdn-staging.foodsworth.com/7a482b591271-9788-ae11-ddac-006cfe46',
          aspect: 1,
          imageFileName: 'airjordan.png',
          type: 'picture',
          thumbUrl:
            'https://cms-cdn-staging.foodsworth.com/375/7a482b591271-9788-ae11-ddac-006cfe46',
          smallUrl:
            'https://cms-cdn-staging.foodsworth.com/750/7a482b591271-9788-ae11-ddac-006cfe46',
          mediumUrl:
            'https://cms-cdn-staging.foodsworth.com/1500/7a482b591271-9788-ae11-ddac-006cfe46',
          largeUrl:
            'https://cms-cdn-staging.foodsworth.com/3000/7a482b591271-9788-ae11-ddac-006cfe46',
        },
      },
      {
        name: 'Air Jordan 77',
        slug: 'silhouette/air-jordan-77',
        sort: 7,
        description: '<p>RAILS 6 TEST</p>',
        metadataDescription: 'test',
        coverAsset: {
          id: 3541720,
          url: 'https://cms-cdn-staging.foodsworth.com/c92c9d987819-073b-ae11-e5ed-0ccdbc45.jpg',
          aspect: 1.77777777777778,
          type: 'picture',
          thumbUrl:
            'https://cms-cdn-staging.foodsworth.com/375/c92c9d987819-073b-ae11-e5ed-0ccdbc45.jpg',
          smallUrl:
            'https://cms-cdn-staging.foodsworth.com/750/c92c9d987819-073b-ae11-e5ed-0ccdbc45.jpg',
          mediumUrl:
            'https://cms-cdn-staging.foodsworth.com/1500/c92c9d987819-073b-ae11-e5ed-0ccdbc45.jpg',
          largeUrl:
            'https://cms-cdn-staging.foodsworth.com/3000/c92c9d987819-073b-ae11-e5ed-0ccdbc45.jpg',
        },
        headerAsset: {
          id: 3544619,
          url: 'https://cms-cdn-staging.foodsworth.com/c92c9d987819-073b-ae11-28ed-08a1cd09.jpg',
          aspect: 0.8,
          type: 'picture',
          thumbUrl:
            'https://cms-cdn-staging.foodsworth.com/375/c92c9d987819-073b-ae11-28ed-08a1cd09.jpg',
          smallUrl:
            'https://cms-cdn-staging.foodsworth.com/750/c92c9d987819-073b-ae11-28ed-08a1cd09.jpg',
          mediumUrl:
            'https://cms-cdn-staging.foodsworth.com/1500/c92c9d987819-073b-ae11-28ed-08a1cd09.jpg',
          largeUrl:
            'https://cms-cdn-staging.foodsworth.com/3000/c92c9d987819-073b-ae11-28ed-08a1cd09.jpg',
        },
      },
      {
        name: 'Air Jodan 99',
        slug: 'silhouette/air-jordan-99',
        sort: 8,
      },
    ],
    'air-jordan': {
      name: 'Air Jordan',
      slug: 'silhouette/air-jordan',
      sort: 1,
      children: [
        {
          name: 'Air Jordan 4',
          slug: 'silhouette/air-jordan/air-jordan-4',
          sort: 1,
        },
      ],
    },
    'air-jordan-5': {
      name: 'Air Jordan 5',
      slug: 'silhouette/air-jordan-5',
      sort: 2,
      description:
        '<p>CMS Description: <a href="http://localhost:5100/sneakers/designer/tinker-hatfield"><ins>Tinker Hatfield</ins></a> channeled Michael Jordan’s aerial combativeness in designing the Jordan Retro 5, adding shark-tooth detailing inspired by WWII fighter planes to the midsole. The shoe also featured a clear outsole, lace locks and &nbsp;a reflective tongue, allowing the sneaker to shine when hit with flash photography.</p>',
      metadataDescription:
        'The shoe also featured a clear outsole, lace locks and a reflective tongue, allowing the sneaker to shine when hit with flash photography.',
      coverAsset: {
        id: 3580899,
        url: 'https://cms-cdn-staging.foodsworth.com/fda67ba46c7e-7389-ae11-789e-06da2880.jpeg',
        aspect: 1.49700598802395,
        imageFileName: 'AJ5.jpeg',
        type: 'picture',
        thumbUrl:
          'https://cms-cdn-staging.foodsworth.com/375/fda67ba46c7e-7389-ae11-789e-06da2880.jpeg',
        smallUrl:
          'https://cms-cdn-staging.foodsworth.com/750/fda67ba46c7e-7389-ae11-789e-06da2880.jpeg',
        mediumUrl:
          'https://cms-cdn-staging.foodsworth.com/1500/fda67ba46c7e-7389-ae11-789e-06da2880.jpeg',
        largeUrl:
          'https://cms-cdn-staging.foodsworth.com/3000/fda67ba46c7e-7389-ae11-789e-06da2880.jpeg',
      },
      headerAsset: {
        id: 3462305,
        url: 'https://cms-cdn-staging.foodsworth.com/7a482b591271-9788-ae11-ddac-006cfe46',
        aspect: 1,
        imageFileName: 'airjordan.png',
        type: 'picture',
        thumbUrl: 'https://cms-cdn-staging.foodsworth.com/375/7a482b591271-9788-ae11-ddac-006cfe46',
        smallUrl: 'https://cms-cdn-staging.foodsworth.com/750/7a482b591271-9788-ae11-ddac-006cfe46',
        mediumUrl:
          'https://cms-cdn-staging.foodsworth.com/1500/7a482b591271-9788-ae11-ddac-006cfe46',
        largeUrl:
          'https://cms-cdn-staging.foodsworth.com/3000/7a482b591271-9788-ae11-ddac-006cfe46',
      },
    },
    'air-jordan-4': {
      name: 'Air Jordan 4',
      slug: 'silhouette/air-jordan-4',
      sort: 3,
      description:
        '<p>CMS Description: The Jordan Retro 4 is the shoe that Michael Jordan wore when he drained ‘the shot’ during the 1989 NBA playoffs. The sneaker would cement its legacy in the Spike Lee film ‘Do the Right Thing,’ a moment in history that signaled the growing cultural currency of the Air Jordan franchise.</p>',
      metadataDescription:
        'The Jordan Retro 4 is the shoe that Michael Jordan wore when he drained ‘the shot’ during the 1989 NBA playoffs.',
      coverAsset: {
        id: 3462305,
        url: 'https://cms-cdn-staging.foodsworth.com/7a482b591271-9788-ae11-ddac-006cfe46',
        aspect: 1,
        imageFileName: 'airjordan.png',
        type: 'picture',
        thumbUrl: 'https://cms-cdn-staging.foodsworth.com/375/7a482b591271-9788-ae11-ddac-006cfe46',
        smallUrl: 'https://cms-cdn-staging.foodsworth.com/750/7a482b591271-9788-ae11-ddac-006cfe46',
        mediumUrl:
          'https://cms-cdn-staging.foodsworth.com/1500/7a482b591271-9788-ae11-ddac-006cfe46',
        largeUrl:
          'https://cms-cdn-staging.foodsworth.com/3000/7a482b591271-9788-ae11-ddac-006cfe46',
      },
      headerAsset: {
        id: 3462305,
        url: 'https://cms-cdn-staging.foodsworth.com/7a482b591271-9788-ae11-ddac-006cfe46',
        aspect: 1,
        imageFileName: 'airjordan.png',
        type: 'picture',
        thumbUrl: 'https://cms-cdn-staging.foodsworth.com/375/7a482b591271-9788-ae11-ddac-006cfe46',
        smallUrl: 'https://cms-cdn-staging.foodsworth.com/750/7a482b591271-9788-ae11-ddac-006cfe46',
        mediumUrl:
          'https://cms-cdn-staging.foodsworth.com/1500/7a482b591271-9788-ae11-ddac-006cfe46',
        largeUrl:
          'https://cms-cdn-staging.foodsworth.com/3000/7a482b591271-9788-ae11-ddac-006cfe46',
      },
    },
    'air-max-97': {
      name: 'Air Max 97',
      slug: 'silhouette/air-max-97',
      sort: 4,
      description:
        '<p>CMS Description: The Nike Air Max 97 may have debuted full-length Air cushioning, but the design of the upper was just as revolutionary. Designer Christian Tresser took inspiration from the concentric lines caused by a single drop of water, while the sneaker’s iconic <a href="http://localhost:5100/sneakers/air-max-97-silver-bullet-884421-001"><ins>‘Silver Bullet’</ins></a> colorway gave the nod to ‘90s mountain bikes.</p>',
      metadataDescription:
        'The Nike Air Max 97 may have debuted full-length Air cushioning, but the design of the upper was just as revolutionary. ',
    },
    'air-jordan-3': {
      name: 'Air Jordan 3',
      slug: 'silhouette/air-jordan-3',
      sort: 5,
      metadataDescription: 'Meta content',
      coverAsset: {
        id: 3580901,
        url: 'https://cms-cdn-staging.foodsworth.com/fda67ba46c7e-7389-ae11-789e-02cd5780.jpeg',
        aspect: 1.68918918918919,
        imageFileName: 'AJ3.jpeg',
        type: 'picture',
        thumbUrl:
          'https://cms-cdn-staging.foodsworth.com/375/fda67ba46c7e-7389-ae11-789e-02cd5780.jpeg',
        smallUrl:
          'https://cms-cdn-staging.foodsworth.com/750/fda67ba46c7e-7389-ae11-789e-02cd5780.jpeg',
        mediumUrl:
          'https://cms-cdn-staging.foodsworth.com/1500/fda67ba46c7e-7389-ae11-789e-02cd5780.jpeg',
        largeUrl:
          'https://cms-cdn-staging.foodsworth.com/3000/fda67ba46c7e-7389-ae11-789e-02cd5780.jpeg',
      },
      headerAsset: {
        id: 3462305,
        url: 'https://cms-cdn-staging.foodsworth.com/7a482b591271-9788-ae11-ddac-006cfe46',
        aspect: 1,
        imageFileName: 'airjordan.png',
        type: 'picture',
        thumbUrl: 'https://cms-cdn-staging.foodsworth.com/375/7a482b591271-9788-ae11-ddac-006cfe46',
        smallUrl: 'https://cms-cdn-staging.foodsworth.com/750/7a482b591271-9788-ae11-ddac-006cfe46',
        mediumUrl:
          'https://cms-cdn-staging.foodsworth.com/1500/7a482b591271-9788-ae11-ddac-006cfe46',
        largeUrl:
          'https://cms-cdn-staging.foodsworth.com/3000/7a482b591271-9788-ae11-ddac-006cfe46',
      },
    },
    'air-jordan-2': {
      name: 'Air Jordan 2',
      slug: 'silhouette/air-jordan-2',
      sort: 6,
      description: '<p>A <em>description</em> can say a lot of <strong>things</strong></p>',
      metadataDescription: 'Meta descriptions can also say a lot of thing',
      coverAsset: {
        id: 3462305,
        url: 'https://cms-cdn-staging.foodsworth.com/7a482b591271-9788-ae11-ddac-006cfe46',
        aspect: 1,
        imageFileName: 'airjordan.png',
        type: 'picture',
        thumbUrl: 'https://cms-cdn-staging.foodsworth.com/375/7a482b591271-9788-ae11-ddac-006cfe46',
        smallUrl: 'https://cms-cdn-staging.foodsworth.com/750/7a482b591271-9788-ae11-ddac-006cfe46',
        mediumUrl:
          'https://cms-cdn-staging.foodsworth.com/1500/7a482b591271-9788-ae11-ddac-006cfe46',
        largeUrl:
          'https://cms-cdn-staging.foodsworth.com/3000/7a482b591271-9788-ae11-ddac-006cfe46',
      },
      headerAsset: {
        id: 3462305,
        url: 'https://cms-cdn-staging.foodsworth.com/7a482b591271-9788-ae11-ddac-006cfe46',
        aspect: 1,
        imageFileName: 'airjordan.png',
        type: 'picture',
        thumbUrl: 'https://cms-cdn-staging.foodsworth.com/375/7a482b591271-9788-ae11-ddac-006cfe46',
        smallUrl: 'https://cms-cdn-staging.foodsworth.com/750/7a482b591271-9788-ae11-ddac-006cfe46',
        mediumUrl:
          'https://cms-cdn-staging.foodsworth.com/1500/7a482b591271-9788-ae11-ddac-006cfe46',
        largeUrl:
          'https://cms-cdn-staging.foodsworth.com/3000/7a482b591271-9788-ae11-ddac-006cfe46',
      },
    },
    'air-jordan-77': {
      name: 'Air Jordan 77',
      slug: 'silhouette/air-jordan-77',
      sort: 7,
      description: '<p>RAILS 6 TEST</p>',
      metadataDescription: 'test',
      coverAsset: {
        id: 3541720,
        url: 'https://cms-cdn-staging.foodsworth.com/c92c9d987819-073b-ae11-e5ed-0ccdbc45.jpg',
        aspect: 1.77777777777778,
        type: 'picture',
        thumbUrl:
          'https://cms-cdn-staging.foodsworth.com/375/c92c9d987819-073b-ae11-e5ed-0ccdbc45.jpg',
        smallUrl:
          'https://cms-cdn-staging.foodsworth.com/750/c92c9d987819-073b-ae11-e5ed-0ccdbc45.jpg',
        mediumUrl:
          'https://cms-cdn-staging.foodsworth.com/1500/c92c9d987819-073b-ae11-e5ed-0ccdbc45.jpg',
        largeUrl:
          'https://cms-cdn-staging.foodsworth.com/3000/c92c9d987819-073b-ae11-e5ed-0ccdbc45.jpg',
      },
      headerAsset: {
        id: 3544619,
        url: 'https://cms-cdn-staging.foodsworth.com/c92c9d987819-073b-ae11-28ed-08a1cd09.jpg',
        aspect: 0.8,
        type: 'picture',
        thumbUrl:
          'https://cms-cdn-staging.foodsworth.com/375/c92c9d987819-073b-ae11-28ed-08a1cd09.jpg',
        smallUrl:
          'https://cms-cdn-staging.foodsworth.com/750/c92c9d987819-073b-ae11-28ed-08a1cd09.jpg',
        mediumUrl:
          'https://cms-cdn-staging.foodsworth.com/1500/c92c9d987819-073b-ae11-28ed-08a1cd09.jpg',
        largeUrl:
          'https://cms-cdn-staging.foodsworth.com/3000/c92c9d987819-073b-ae11-28ed-08a1cd09.jpg',
      },
    },
    'air-jordan-99': {
      name: 'Air Jodan 99',
      slug: 'silhouette/air-jordan-99',
      sort: 8,
    },
  },
  technology: {
    name: 'Technology',
    slug: 'technology',
    sort: 2,
    children: [
      {
        name: 'Boost',
        slug: 'technology/boost',
        sort: 1,
        description:
          '<p>CMS Description: From the labs at BASF to all facets of <a href="/sneakers/brand/adidas"><ins>adidas footwear</ins>,</a> Boost has shown its versatility all while delivering maximum energy return with every day wearability.</p>',
        metadataDescription:
          ' Boost has shown its versatility all while delivering maximum energy return with every day wearability.',
        headerAsset: {
          id: 3463469,
          url: 'https://cms-cdn-staging.foodsworth.com/7a482b591271-9788-ae11-b8bc-09894850',
          aspect: 1,
          imageFileName: 'adidas.png',
          type: 'picture',
          thumbUrl:
            'https://cms-cdn-staging.foodsworth.com/375/7a482b591271-9788-ae11-b8bc-09894850',
          smallUrl:
            'https://cms-cdn-staging.foodsworth.com/750/7a482b591271-9788-ae11-b8bc-09894850',
          mediumUrl:
            'https://cms-cdn-staging.foodsworth.com/1500/7a482b591271-9788-ae11-b8bc-09894850',
          largeUrl:
            'https://cms-cdn-staging.foodsworth.com/3000/7a482b591271-9788-ae11-b8bc-09894850',
        },
      },
    ],
    boost: {
      name: 'Boost',
      slug: 'technology/boost',
      sort: 1,
      description:
        '<p>CMS Description: From the labs at BASF to all facets of <a href="/sneakers/brand/adidas"><ins>adidas footwear</ins>,</a> Boost has shown its versatility all while delivering maximum energy return with every day wearability.</p>',
      metadataDescription:
        ' Boost has shown its versatility all while delivering maximum energy return with every day wearability.',
      headerAsset: {
        id: 3463469,
        url: 'https://cms-cdn-staging.foodsworth.com/7a482b591271-9788-ae11-b8bc-09894850',
        aspect: 1,
        imageFileName: 'adidas.png',
        type: 'picture',
        thumbUrl: 'https://cms-cdn-staging.foodsworth.com/375/7a482b591271-9788-ae11-b8bc-09894850',
        smallUrl: 'https://cms-cdn-staging.foodsworth.com/750/7a482b591271-9788-ae11-b8bc-09894850',
        mediumUrl:
          'https://cms-cdn-staging.foodsworth.com/1500/7a482b591271-9788-ae11-b8bc-09894850',
        largeUrl:
          'https://cms-cdn-staging.foodsworth.com/3000/7a482b591271-9788-ae11-b8bc-09894850',
      },
    },
  },
  designer: {
    name: 'Designer',
    slug: 'designer',
    sort: 3,
    children: [
      {
        name: 'Tinker Hatfield',
        slug: 'designer/tinker-hatfield',
        sort: 1,
        description:
          '<p>Tinker write up: Starting off as an architect, Tinker Hatfield applied his structural and construction knowledge into some of the most legendary sneaker designs. Leading the charge on some of the most influential <a href="http://localhost:5100/sneakers/brand/nike"><ins>Nike</ins></a> and <a href="http://localhost:5100/sneakers/brand/air-jordan"><ins>Air Jordan</ins></a> designs, Hatfield continues to innovate over a 30+ year career.</p>',
        metadataDescription:
          'Leading the charge on some of the most influential Nike and Air Jordan designs, Hatfield continues to innovate over a 30+ year career.',
        coverAsset: {
          id: 3431902,
          url: 'https://cms-cdn-staging.foodsworth.com/45733f7cbc54-8999-ae11-f45c-0ba51b10',
          aspect: 1.5,
          type: 'picture',
          thumbUrl:
            'https://cms-cdn-staging.foodsworth.com/375/45733f7cbc54-8999-ae11-f45c-0ba51b10',
          smallUrl:
            'https://cms-cdn-staging.foodsworth.com/750/45733f7cbc54-8999-ae11-f45c-0ba51b10',
          mediumUrl:
            'https://cms-cdn-staging.foodsworth.com/1500/45733f7cbc54-8999-ae11-f45c-0ba51b10',
          largeUrl:
            'https://cms-cdn-staging.foodsworth.com/3000/45733f7cbc54-8999-ae11-f45c-0ba51b10',
        },
        headerAsset: {
          id: 3463469,
          url: 'https://cms-cdn-staging.foodsworth.com/7a482b591271-9788-ae11-b8bc-09894850',
          aspect: 1,
          imageFileName: 'adidas.png',
          type: 'picture',
          thumbUrl:
            'https://cms-cdn-staging.foodsworth.com/375/7a482b591271-9788-ae11-b8bc-09894850',
          smallUrl:
            'https://cms-cdn-staging.foodsworth.com/750/7a482b591271-9788-ae11-b8bc-09894850',
          mediumUrl:
            'https://cms-cdn-staging.foodsworth.com/1500/7a482b591271-9788-ae11-b8bc-09894850',
          largeUrl:
            'https://cms-cdn-staging.foodsworth.com/3000/7a482b591271-9788-ae11-b8bc-09894850',
        },
      },
    ],
    'tinker-hatfield': {
      name: 'Tinker Hatfield',
      slug: 'designer/tinker-hatfield',
      sort: 1,
      description:
        '<p>Tinker write up: Starting off as an architect, Tinker Hatfield applied his structural and construction knowledge into some of the most legendary sneaker designs. Leading the charge on some of the most influential <a href="http://localhost:5100/sneakers/brand/nike"><ins>Nike</ins></a> and <a href="http://localhost:5100/sneakers/brand/air-jordan"><ins>Air Jordan</ins></a> designs, Hatfield continues to innovate over a 30+ year career.</p>',
      metadataDescription:
        'Leading the charge on some of the most influential Nike and Air Jordan designs, Hatfield continues to innovate over a 30+ year career.',
      coverAsset: {
        id: 3431902,
        url: 'https://cms-cdn-staging.foodsworth.com/45733f7cbc54-8999-ae11-f45c-0ba51b10',
        aspect: 1.5,
        type: 'picture',
        thumbUrl: 'https://cms-cdn-staging.foodsworth.com/375/45733f7cbc54-8999-ae11-f45c-0ba51b10',
        smallUrl: 'https://cms-cdn-staging.foodsworth.com/750/45733f7cbc54-8999-ae11-f45c-0ba51b10',
        mediumUrl:
          'https://cms-cdn-staging.foodsworth.com/1500/45733f7cbc54-8999-ae11-f45c-0ba51b10',
        largeUrl:
          'https://cms-cdn-staging.foodsworth.com/3000/45733f7cbc54-8999-ae11-f45c-0ba51b10',
      },
      headerAsset: {
        id: 3463469,
        url: 'https://cms-cdn-staging.foodsworth.com/7a482b591271-9788-ae11-b8bc-09894850',
        aspect: 1,
        imageFileName: 'adidas.png',
        type: 'picture',
        thumbUrl: 'https://cms-cdn-staging.foodsworth.com/375/7a482b591271-9788-ae11-b8bc-09894850',
        smallUrl: 'https://cms-cdn-staging.foodsworth.com/750/7a482b591271-9788-ae11-b8bc-09894850',
        mediumUrl:
          'https://cms-cdn-staging.foodsworth.com/1500/7a482b591271-9788-ae11-b8bc-09894850',
        largeUrl:
          'https://cms-cdn-staging.foodsworth.com/3000/7a482b591271-9788-ae11-b8bc-09894850',
      },
    },
  },
  brand: {
    name: 'Brand',
    slug: 'brand',
    sort: 4,
    children: [
      {
        name: 'Alexander McQueen',
        slug: 'brand/alexander-mcqueen',
        sort: 1,
        description:
          '<p>Alexander McQueen is a British luxury fashion brand founded in 1992. Its namesake designer put his label on the map with avant-garde collections and theatrical fashion shows. Since McQueen’s passing in 2010, the label has been under the direction of his longtime right hand woman, Sarah Burton.<br>\n</p>',
        coverAsset: {
          id: 3722644,
          url: 'https://cms-cdn-staging.foodsworth.com/72b9e50c3692-3669-be11-31f0-0d0bf04c.jpg',
          aspect: 1.18770226537217,
          imageFileName: 'fd970706ba7d-4549-be11-8990-0cd5b7af.jpg',
          type: 'picture',
          thumbUrl:
            'https://cms-cdn-staging.foodsworth.com/375/72b9e50c3692-3669-be11-31f0-0d0bf04c.jpg',
          smallUrl:
            'https://cms-cdn-staging.foodsworth.com/750/72b9e50c3692-3669-be11-31f0-0d0bf04c.jpg',
          mediumUrl:
            'https://cms-cdn-staging.foodsworth.com/1500/72b9e50c3692-3669-be11-31f0-0d0bf04c.jpg',
          largeUrl:
            'https://cms-cdn-staging.foodsworth.com/3000/72b9e50c3692-3669-be11-31f0-0d0bf04c.jpg',
        },
        headerAsset: {
          id: 3473310,
          url: 'https://cms-cdn-staging.foodsworth.com/9a779c3b9bf6-8778-ae11-e2dc-0c022b7a',
          aspect: 0.463714637146371,
          imageFileName: 'image (15).png',
          type: 'picture',
          thumbUrl:
            'https://cms-cdn-staging.foodsworth.com/375/9a779c3b9bf6-8778-ae11-e2dc-0c022b7a',
          smallUrl:
            'https://cms-cdn-staging.foodsworth.com/750/9a779c3b9bf6-8778-ae11-e2dc-0c022b7a',
          mediumUrl:
            'https://cms-cdn-staging.foodsworth.com/1500/9a779c3b9bf6-8778-ae11-e2dc-0c022b7a',
          largeUrl:
            'https://cms-cdn-staging.foodsworth.com/3000/9a779c3b9bf6-8778-ae11-e2dc-0c022b7a',
        },
      },
      {
        name: 'Supreme',
        slug: 'brand/supreme',
        sort: 2,
        description:
          '<p>Founded in 1994 by James Jebbia, Supreme is considered the most influential voice in streetwear. The New York skate brand is known for elevating subcultures through collaborative and subversive methods, working with everyone from Nike and COMME des GARCONS to Larry Clark and Jeff Koons.</p>',
        metadataDescription:
          'Founded in 1994 by James Jebbia, Supreme is considered the most influential voice in streetwear. The New York skate brand is known for elevating subcultures through collaborative and subversive methods, working with everyone from Nike and COMME des GARCONS to Larry Clark and Jeff Koons.',
        coverAsset: {
          id: 3399699,
          url: 'https://cms-cdn-staging.foodsworth.com/6eb170822add-ddba-ae11-a07b-0b5545d4',
          aspect: 2.42857142857143,
          imageFileName: 'eea9681f1431-fc2a-ae11-ffca-01387f63 (1).jpeg',
          type: 'picture',
          thumbUrl:
            'https://cms-cdn-staging.foodsworth.com/375/6eb170822add-ddba-ae11-a07b-0b5545d4',
          smallUrl:
            'https://cms-cdn-staging.foodsworth.com/750/6eb170822add-ddba-ae11-a07b-0b5545d4',
          mediumUrl:
            'https://cms-cdn-staging.foodsworth.com/1500/6eb170822add-ddba-ae11-a07b-0b5545d4',
          largeUrl:
            'https://cms-cdn-staging.foodsworth.com/3000/6eb170822add-ddba-ae11-a07b-0b5545d4',
        },
      },
      {
        name: 'Acne Studios',
        slug: 'brand/acne-studios',
        sort: 3,
        description:
          '<p>Art, architecture and contemporary culture form the basis of Acne Studios\' unconventional ethos. A creative collective born in 1996, the Swedish fashion house came onto Vogue Paris\' radar after co-founder Jonny Johansson designed 100 pairs of raw denim <a href="https://goat-staging.labs.goateng.com/search?query=jeans"><ins>jeans</ins></a> with red stitching for friends and family.</p>',
        metadataDescription:
          "Art, architecture and contemporary culture form the basis of Acne Studios' unconventional ethos.",
        coverAsset: {
          id: 3722641,
          url: 'https://cms-cdn-staging.foodsworth.com/72b9e50c3692-3669-be11-31f0-0d7c024c.jpg',
          aspect: 0.799847211611918,
          imageFileName: '9f10af0caa5d-089a-ae11-483f-027e7749.jpg',
          type: 'picture',
          thumbUrl:
            'https://cms-cdn-staging.foodsworth.com/375/72b9e50c3692-3669-be11-31f0-0d7c024c.jpg',
          smallUrl:
            'https://cms-cdn-staging.foodsworth.com/750/72b9e50c3692-3669-be11-31f0-0d7c024c.jpg',
          mediumUrl:
            'https://cms-cdn-staging.foodsworth.com/1500/72b9e50c3692-3669-be11-31f0-0d7c024c.jpg',
          largeUrl:
            'https://cms-cdn-staging.foodsworth.com/3000/72b9e50c3692-3669-be11-31f0-0d7c024c.jpg',
        },
        headerAsset: {
          id: 3525051,
          url: 'https://cms-cdn-staging.foodsworth.com/a6aac84752bd-6fdb-ae11-c0cd-051d775f',
          aspect: 6.97333333333333,
          imageFileName: 'acnestudios.png',
          type: 'picture',
          thumbUrl:
            'https://cms-cdn-staging.foodsworth.com/375/a6aac84752bd-6fdb-ae11-c0cd-051d775f',
          smallUrl:
            'https://cms-cdn-staging.foodsworth.com/750/a6aac84752bd-6fdb-ae11-c0cd-051d775f',
          mediumUrl:
            'https://cms-cdn-staging.foodsworth.com/1500/a6aac84752bd-6fdb-ae11-c0cd-051d775f',
          largeUrl:
            'https://cms-cdn-staging.foodsworth.com/3000/a6aac84752bd-6fdb-ae11-c0cd-051d775f',
        },
      },
      {
        name: 'MCQ',
        slug: 'brand/mcq',
        sort: 4,
        description: '',
        metadataDescription: 'Meta data',
        headerAsset: {
          id: 3541499,
          url: 'https://cms-cdn-staging.foodsworth.com/c92c9d987819-073b-ae11-95ed-0f1c4d63.png',
          aspect: 2.41176470588235,
          imageFileName: 'Logo - MCQ_White.png',
          type: 'picture',
          thumbUrl:
            'https://cms-cdn-staging.foodsworth.com/375/c92c9d987819-073b-ae11-95ed-0f1c4d63.png',
          smallUrl:
            'https://cms-cdn-staging.foodsworth.com/750/c92c9d987819-073b-ae11-95ed-0f1c4d63.png',
          mediumUrl:
            'https://cms-cdn-staging.foodsworth.com/1500/c92c9d987819-073b-ae11-95ed-0f1c4d63.png',
          largeUrl:
            'https://cms-cdn-staging.foodsworth.com/3000/c92c9d987819-073b-ae11-95ed-0f1c4d63.png',
        },
      },
      {
        name: 'Wrong Name',
        slug: 'brand/comme-des-garcons',
        sort: 5,
        description: '',
      },
      {
        name: 'Gucci',
        slug: 'brand/gucci',
        sort: 6,
        coverAsset: {
          id: 3722643,
          url: 'https://cms-cdn-staging.foodsworth.com/72b9e50c3692-3669-be11-31f0-071a924c.jpeg',
          aspect: 0.666666666666667,
          imageFileName: '7db5e2f255d8-5849-ae11-9375-0b684084.jpeg',
          type: 'picture',
          thumbUrl:
            'https://cms-cdn-staging.foodsworth.com/375/72b9e50c3692-3669-be11-31f0-071a924c.jpeg',
          smallUrl:
            'https://cms-cdn-staging.foodsworth.com/750/72b9e50c3692-3669-be11-31f0-071a924c.jpeg',
          mediumUrl:
            'https://cms-cdn-staging.foodsworth.com/1500/72b9e50c3692-3669-be11-31f0-071a924c.jpeg',
          largeUrl:
            'https://cms-cdn-staging.foodsworth.com/3000/72b9e50c3692-3669-be11-31f0-071a924c.jpeg',
        },
      },
    ],
    'alexander-mcqueen': {
      name: 'Alexander McQueen',
      slug: 'brand/alexander-mcqueen',
      sort: 1,
      description:
        '<p>Alexander McQueen is a British luxury fashion brand founded in 1992. Its namesake designer put his label on the map with avant-garde collections and theatrical fashion shows. Since McQueen’s passing in 2010, the label has been under the direction of his longtime right hand woman, Sarah Burton.<br>\n</p>',
      coverAsset: {
        id: 3722644,
        url: 'https://cms-cdn-staging.foodsworth.com/72b9e50c3692-3669-be11-31f0-0d0bf04c.jpg',
        aspect: 1.18770226537217,
        imageFileName: 'fd970706ba7d-4549-be11-8990-0cd5b7af.jpg',
        type: 'picture',
        thumbUrl:
          'https://cms-cdn-staging.foodsworth.com/375/72b9e50c3692-3669-be11-31f0-0d0bf04c.jpg',
        smallUrl:
          'https://cms-cdn-staging.foodsworth.com/750/72b9e50c3692-3669-be11-31f0-0d0bf04c.jpg',
        mediumUrl:
          'https://cms-cdn-staging.foodsworth.com/1500/72b9e50c3692-3669-be11-31f0-0d0bf04c.jpg',
        largeUrl:
          'https://cms-cdn-staging.foodsworth.com/3000/72b9e50c3692-3669-be11-31f0-0d0bf04c.jpg',
      },
      headerAsset: {
        id: 3473310,
        url: 'https://cms-cdn-staging.foodsworth.com/9a779c3b9bf6-8778-ae11-e2dc-0c022b7a',
        aspect: 0.463714637146371,
        imageFileName: 'image (15).png',
        type: 'picture',
        thumbUrl: 'https://cms-cdn-staging.foodsworth.com/375/9a779c3b9bf6-8778-ae11-e2dc-0c022b7a',
        smallUrl: 'https://cms-cdn-staging.foodsworth.com/750/9a779c3b9bf6-8778-ae11-e2dc-0c022b7a',
        mediumUrl:
          'https://cms-cdn-staging.foodsworth.com/1500/9a779c3b9bf6-8778-ae11-e2dc-0c022b7a',
        largeUrl:
          'https://cms-cdn-staging.foodsworth.com/3000/9a779c3b9bf6-8778-ae11-e2dc-0c022b7a',
      },
    },
    supreme: {
      name: 'Supreme',
      slug: 'brand/supreme',
      sort: 2,
      description:
        '<p>Founded in 1994 by James Jebbia, Supreme is considered the most influential voice in streetwear. The New York skate brand is known for elevating subcultures through collaborative and subversive methods, working with everyone from Nike and COMME des GARCONS to Larry Clark and Jeff Koons.</p>',
      metadataDescription:
        'Founded in 1994 by James Jebbia, Supreme is considered the most influential voice in streetwear. The New York skate brand is known for elevating subcultures through collaborative and subversive methods, working with everyone from Nike and COMME des GARCONS to Larry Clark and Jeff Koons.',
      coverAsset: {
        id: 3399699,
        url: 'https://cms-cdn-staging.foodsworth.com/6eb170822add-ddba-ae11-a07b-0b5545d4',
        aspect: 2.42857142857143,
        imageFileName: 'eea9681f1431-fc2a-ae11-ffca-01387f63 (1).jpeg',
        type: 'picture',
        thumbUrl: 'https://cms-cdn-staging.foodsworth.com/375/6eb170822add-ddba-ae11-a07b-0b5545d4',
        smallUrl: 'https://cms-cdn-staging.foodsworth.com/750/6eb170822add-ddba-ae11-a07b-0b5545d4',
        mediumUrl:
          'https://cms-cdn-staging.foodsworth.com/1500/6eb170822add-ddba-ae11-a07b-0b5545d4',
        largeUrl:
          'https://cms-cdn-staging.foodsworth.com/3000/6eb170822add-ddba-ae11-a07b-0b5545d4',
      },
    },
    'acne-studios': {
      name: 'Acne Studios',
      slug: 'brand/acne-studios',
      sort: 3,
      description:
        '<p>Art, architecture and contemporary culture form the basis of Acne Studios\' unconventional ethos. A creative collective born in 1996, the Swedish fashion house came onto Vogue Paris\' radar after co-founder Jonny Johansson designed 100 pairs of raw denim <a href="https://goat-staging.labs.goateng.com/search?query=jeans"><ins>jeans</ins></a> with red stitching for friends and family.</p>',
      metadataDescription:
        "Art, architecture and contemporary culture form the basis of Acne Studios' unconventional ethos.",
      coverAsset: {
        id: 3722641,
        url: 'https://cms-cdn-staging.foodsworth.com/72b9e50c3692-3669-be11-31f0-0d7c024c.jpg',
        aspect: 0.799847211611918,
        imageFileName: '9f10af0caa5d-089a-ae11-483f-027e7749.jpg',
        type: 'picture',
        thumbUrl:
          'https://cms-cdn-staging.foodsworth.com/375/72b9e50c3692-3669-be11-31f0-0d7c024c.jpg',
        smallUrl:
          'https://cms-cdn-staging.foodsworth.com/750/72b9e50c3692-3669-be11-31f0-0d7c024c.jpg',
        mediumUrl:
          'https://cms-cdn-staging.foodsworth.com/1500/72b9e50c3692-3669-be11-31f0-0d7c024c.jpg',
        largeUrl:
          'https://cms-cdn-staging.foodsworth.com/3000/72b9e50c3692-3669-be11-31f0-0d7c024c.jpg',
      },
      headerAsset: {
        id: 3525051,
        url: 'https://cms-cdn-staging.foodsworth.com/a6aac84752bd-6fdb-ae11-c0cd-051d775f',
        aspect: 6.97333333333333,
        imageFileName: 'acnestudios.png',
        type: 'picture',
        thumbUrl: 'https://cms-cdn-staging.foodsworth.com/375/a6aac84752bd-6fdb-ae11-c0cd-051d775f',
        smallUrl: 'https://cms-cdn-staging.foodsworth.com/750/a6aac84752bd-6fdb-ae11-c0cd-051d775f',
        mediumUrl:
          'https://cms-cdn-staging.foodsworth.com/1500/a6aac84752bd-6fdb-ae11-c0cd-051d775f',
        largeUrl:
          'https://cms-cdn-staging.foodsworth.com/3000/a6aac84752bd-6fdb-ae11-c0cd-051d775f',
      },
    },
    mcq: {
      name: 'MCQ',
      slug: 'brand/mcq',
      sort: 4,
      description: '',
      metadataDescription: 'Meta data',
      headerAsset: {
        id: 3541499,
        url: 'https://cms-cdn-staging.foodsworth.com/c92c9d987819-073b-ae11-95ed-0f1c4d63.png',
        aspect: 2.41176470588235,
        imageFileName: 'Logo - MCQ_White.png',
        type: 'picture',
        thumbUrl:
          'https://cms-cdn-staging.foodsworth.com/375/c92c9d987819-073b-ae11-95ed-0f1c4d63.png',
        smallUrl:
          'https://cms-cdn-staging.foodsworth.com/750/c92c9d987819-073b-ae11-95ed-0f1c4d63.png',
        mediumUrl:
          'https://cms-cdn-staging.foodsworth.com/1500/c92c9d987819-073b-ae11-95ed-0f1c4d63.png',
        largeUrl:
          'https://cms-cdn-staging.foodsworth.com/3000/c92c9d987819-073b-ae11-95ed-0f1c4d63.png',
      },
    },
    'comme-des-garcons': {
      name: 'Wrong Name',
      slug: 'brand/comme-des-garcons',
      sort: 5,
      description: '',
    },
    gucci: {
      name: 'Gucci',
      slug: 'brand/gucci',
      sort: 6,
      coverAsset: {
        id: 3722643,
        url: 'https://cms-cdn-staging.foodsworth.com/72b9e50c3692-3669-be11-31f0-071a924c.jpeg',
        aspect: 0.666666666666667,
        imageFileName: '7db5e2f255d8-5849-ae11-9375-0b684084.jpeg',
        type: 'picture',
        thumbUrl:
          'https://cms-cdn-staging.foodsworth.com/375/72b9e50c3692-3669-be11-31f0-071a924c.jpeg',
        smallUrl:
          'https://cms-cdn-staging.foodsworth.com/750/72b9e50c3692-3669-be11-31f0-071a924c.jpeg',
        mediumUrl:
          'https://cms-cdn-staging.foodsworth.com/1500/72b9e50c3692-3669-be11-31f0-071a924c.jpeg',
        largeUrl:
          'https://cms-cdn-staging.foodsworth.com/3000/72b9e50c3692-3669-be11-31f0-071a924c.jpeg',
      },
    },
  },
  timeline: {
    name: 'Timeline',
    slug: 'timeline',
    sort: 5,
    children: [
      {
        name: 'Years',
        slug: 'timeline/years',
        sort: 3,
        children: [
          {
            name: '2016',
            slug: 'timeline/years/2016',
            sort: 1,
            description:
              '<p>A full year of releases, including the adidas Futurecraft 3D, Rihanna Puma collection, UltraBoost, NMD and Nike HyperAdapt 1.0</p>',
          },
          {
            name: '2017',
            slug: 'timeline/years/2017',
            sort: 2,
            description:
              "<p>Chicago natives dominated 2017, with Kanye launching the Waverunner 700 and Virgil working on the Off-White x Nike 'The Ten'&nbsp;</p>",
          },
          {
            name: '2018',
            slug: 'timeline/years/2018',
            sort: 3,
            description:
              '<p>Lifestyle collabs and Yeezy dominate, with the Sean Wotherspoon Air Max 1/97, Travis Scott x AJ4 and Fear Of God releasing</p>',
          },
          {
            name: '2019',
            slug: 'timeline/years/2019',
            sort: 4,
            description:
              '<p>2019 continues the trend of style overtaking performance. Top styles include adidas Yeezys and the 30th anniversary of the AJ4</p>',
          },
          {
            name: '2020',
            slug: 'timeline/years/2020',
            sort: 5,
            description:
              '<p>Lifestyle collabs continue, led by the Dior x AJ1 and Union x AJ4. Yeezy and Kobe both see great styles and colors release</p>',
          },
          {
            name: '2015',
            slug: 'timeline/years/2015',
            sort: 6,
            description:
              "<p>adidas dominates with the UltraBoost, NMD and Yeezy 350. Nike launched the AJ11 '72-10' as well as the Drake Air Jordan 10 x OVO</p>",
          },
          {
            name: '2014',
            slug: 'timeline/years/2014',
            sort: 7,
            description:
              '<p>Rick Owens and Raf Simons work with adidas, while Fragment Design and Jordan Brand link up on an Air Jordan 1 Retro</p>',
          },
          {
            name: '2013',
            slug: 'timeline/years/2013',
            sort: 8,
            description:
              '<p>The Air Jordan 1 returns in several new and original colors, including the Chicago, Bred, Black Toe, Royal and more</p>',
          },
          {
            name: '2012',
            slug: 'timeline/years/2012',
            sort: 9,
            description:
              "<p>The 'Galaxy' Foamposite causes riots during Orlando All-Star Weekend, while Nike unveils Flyknit technology at the Summer Olympics</p>",
          },
          {
            name: '2011',
            slug: 'timeline/years/2011',
            sort: 10,
            description:
              "<p>Back from the Future, the Nike Mag sees a limited release for charity. Ronnie Fieg works with ASICS on the 'Salmon Toe' Gel Lyte 3</p>",
          },
          {
            name: '2010',
            slug: 'timeline/years/2010',
            sort: 11,
            description:
              "<p>A pair of Nike Basketball shoes headline 2010, with the LeBron 8 'South Beach' and Kobe 6 'Grinch' both using bright vivid colors</p>",
          },
          {
            name: '2009',
            slug: 'timeline/years/2009',
            sort: 12,
            description:
              '<p>Kanye West debuted the Nike Air Yeezy, the first non-athlete signature shoe. The Kobe 4 turned heads as a true low-top hoops shoe</p>',
          },
          {
            name: '2008',
            slug: 'timeline/years/2008',
            sort: 13,
            description:
              '<p>Nike unveils Flywire at the Beijing Olympics, highlighted by the new lightweight basketball shoe, the Nike Hyperdunk</p>',
          },
          {
            name: '2007',
            slug: 'timeline/years/2007',
            sort: 14,
            description:
              "<p>ASICS starts working with Ronnie Fieg, releasing the Fieg 252 pack. Nike SB unveils the 'What The' concept on the Dunk Low SB</p>",
          },
          {
            name: '2006',
            slug: 'timeline/years/2006',
            sort: 15,
            description:
              "<p>Japanese brand A Bathing Ape's Bapesta sees mainstream success, while Kobe launches his first Nike signature shoe, the Zoom Kobe 1</p>",
          },
          {
            name: '2005',
            slug: 'timeline/years/2005',
            sort: 16,
            description: '',
          },
          {
            name: '2004',
            slug: 'timeline/years/2004',
            sort: 17,
          },
          {
            name: '2003',
            slug: 'timeline/years/2003',
            sort: 18,
          },
          {
            name: '2002',
            slug: 'timeline/years/2002',
            sort: 19,
          },
          {
            name: '2001',
            slug: 'timeline/years/2001',
            sort: 20,
          },
          {
            name: '2000',
            slug: 'timeline/years/2000',
            sort: 21,
          },
          {
            name: '1999',
            slug: 'timeline/years/1999',
            sort: 22,
          },
          {
            name: '1998',
            slug: 'timeline/years/1998',
            sort: 23,
          },
          {
            name: '1997',
            slug: 'timeline/years/1997',
            sort: 24,
          },
          {
            name: '1996',
            slug: 'timeline/years/1996',
            sort: 25,
          },
          {
            name: '1995',
            slug: 'timeline/years/1995',
            sort: 26,
          },
          {
            name: '1994',
            slug: 'timeline/years/1994',
            sort: 27,
          },
          {
            name: '1991',
            slug: 'timeline/years/1991',
            sort: 28,
          },
          {
            name: '1993',
            slug: 'timeline/years/1993',
            sort: 29,
          },
          {
            name: '1992',
            slug: 'timeline/years/1992',
            sort: 30,
          },
          {
            name: '1990',
            slug: 'timeline/years/1990',
            sort: 31,
          },
          {
            name: '1989',
            slug: 'timeline/years/1989',
            sort: 32,
          },
          {
            name: '1988',
            slug: 'timeline/years/1988',
            sort: 33,
          },
          {
            name: '1987',
            slug: 'timeline/years/1987',
            sort: 34,
          },
          {
            name: '1986',
            slug: 'timeline/years/1986',
            sort: 35,
          },
          {
            name: '1985',
            slug: 'timeline/years/1985',
            sort: 36,
          },
        ],
      },
      {
        name: 'Silhouettes',
        slug: 'timeline/silhouettes',
        sort: 4,
        children: [
          {
            name: 'Air Force 1',
            slug: 'timeline/silhouettes/air-force-1',
            sort: 1,
            coverAsset: {
              id: 3580872,
              url: 'https://cms-cdn-staging.foodsworth.com/fda67ba46c7e-7389-ae11-689e-030c4d24.jpeg',
              aspect: 2.10084033613445,
              imageFileName: 'AF1.jpeg',
              type: 'picture',
              thumbUrl:
                'https://cms-cdn-staging.foodsworth.com/375/fda67ba46c7e-7389-ae11-689e-030c4d24.jpeg',
              smallUrl:
                'https://cms-cdn-staging.foodsworth.com/750/fda67ba46c7e-7389-ae11-689e-030c4d24.jpeg',
              mediumUrl:
                'https://cms-cdn-staging.foodsworth.com/1500/fda67ba46c7e-7389-ae11-689e-030c4d24.jpeg',
              largeUrl:
                'https://cms-cdn-staging.foodsworth.com/3000/fda67ba46c7e-7389-ae11-689e-030c4d24.jpeg',
            },
          },
          {
            name: 'Air Jordan 1',
            slug: 'timeline/silhouettes/air-jordan-1',
            sort: 2,
            coverAsset: {
              id: 3580900,
              url: 'https://cms-cdn-staging.foodsworth.com/fda67ba46c7e-7389-ae11-789e-0ce9d680.jpeg',
              aspect: 1.61812297734628,
              imageFileName: 'AJ1.jpeg',
              type: 'picture',
              thumbUrl:
                'https://cms-cdn-staging.foodsworth.com/375/fda67ba46c7e-7389-ae11-789e-0ce9d680.jpeg',
              smallUrl:
                'https://cms-cdn-staging.foodsworth.com/750/fda67ba46c7e-7389-ae11-789e-0ce9d680.jpeg',
              mediumUrl:
                'https://cms-cdn-staging.foodsworth.com/1500/fda67ba46c7e-7389-ae11-789e-0ce9d680.jpeg',
              largeUrl:
                'https://cms-cdn-staging.foodsworth.com/3000/fda67ba46c7e-7389-ae11-789e-0ce9d680.jpeg',
            },
          },
          {
            name: 'Air Jordan 3',
            slug: 'timeline/silhouettes/air-jordan-3',
            sort: 3,
            coverAsset: {
              id: 3580901,
              url: 'https://cms-cdn-staging.foodsworth.com/fda67ba46c7e-7389-ae11-789e-02cd5780.jpeg',
              aspect: 1.68918918918919,
              imageFileName: 'AJ3.jpeg',
              type: 'picture',
              thumbUrl:
                'https://cms-cdn-staging.foodsworth.com/375/fda67ba46c7e-7389-ae11-789e-02cd5780.jpeg',
              smallUrl:
                'https://cms-cdn-staging.foodsworth.com/750/fda67ba46c7e-7389-ae11-789e-02cd5780.jpeg',
              mediumUrl:
                'https://cms-cdn-staging.foodsworth.com/1500/fda67ba46c7e-7389-ae11-789e-02cd5780.jpeg',
              largeUrl:
                'https://cms-cdn-staging.foodsworth.com/3000/fda67ba46c7e-7389-ae11-789e-02cd5780.jpeg',
            },
          },
          {
            name: 'Air Jordan 4',
            slug: 'timeline/silhouettes/air-jordan-4',
            sort: 4,
            coverAsset: {
              id: 3580898,
              url: 'https://cms-cdn-staging.foodsworth.com/fda67ba46c7e-7389-ae11-789e-0bd1c780.jpeg',
              aspect: 1.56739811912226,
              imageFileName: 'AJ4.jpeg',
              type: 'picture',
              thumbUrl:
                'https://cms-cdn-staging.foodsworth.com/375/fda67ba46c7e-7389-ae11-789e-0bd1c780.jpeg',
              smallUrl:
                'https://cms-cdn-staging.foodsworth.com/750/fda67ba46c7e-7389-ae11-789e-0bd1c780.jpeg',
              mediumUrl:
                'https://cms-cdn-staging.foodsworth.com/1500/fda67ba46c7e-7389-ae11-789e-0bd1c780.jpeg',
              largeUrl:
                'https://cms-cdn-staging.foodsworth.com/3000/fda67ba46c7e-7389-ae11-789e-0bd1c780.jpeg',
            },
          },
          {
            name: 'Air Jordan 5',
            slug: 'timeline/silhouettes/air-jordan-5',
            sort: 5,
            coverAsset: {
              id: 3580899,
              url: 'https://cms-cdn-staging.foodsworth.com/fda67ba46c7e-7389-ae11-789e-06da2880.jpeg',
              aspect: 1.49700598802395,
              imageFileName: 'AJ5.jpeg',
              type: 'picture',
              thumbUrl:
                'https://cms-cdn-staging.foodsworth.com/375/fda67ba46c7e-7389-ae11-789e-06da2880.jpeg',
              smallUrl:
                'https://cms-cdn-staging.foodsworth.com/750/fda67ba46c7e-7389-ae11-789e-06da2880.jpeg',
              mediumUrl:
                'https://cms-cdn-staging.foodsworth.com/1500/fda67ba46c7e-7389-ae11-789e-06da2880.jpeg',
              largeUrl:
                'https://cms-cdn-staging.foodsworth.com/3000/fda67ba46c7e-7389-ae11-789e-06da2880.jpeg',
            },
          },
          {
            name: 'Air Jordan 11',
            slug: 'timeline/silhouettes/air-jordan-11',
            sort: 6,
            coverAsset: {
              id: 3580897,
              url: 'https://cms-cdn-staging.foodsworth.com/fda67ba46c7e-7389-ae11-789e-0fd76880.jpeg',
              aspect: 1.78571428571429,
              imageFileName: 'AJ11.jpeg',
              type: 'picture',
              thumbUrl:
                'https://cms-cdn-staging.foodsworth.com/375/fda67ba46c7e-7389-ae11-789e-0fd76880.jpeg',
              smallUrl:
                'https://cms-cdn-staging.foodsworth.com/750/fda67ba46c7e-7389-ae11-789e-0fd76880.jpeg',
              mediumUrl:
                'https://cms-cdn-staging.foodsworth.com/1500/fda67ba46c7e-7389-ae11-789e-0fd76880.jpeg',
              largeUrl:
                'https://cms-cdn-staging.foodsworth.com/3000/fda67ba46c7e-7389-ae11-789e-0fd76880.jpeg',
            },
          },
          {
            name: 'Air Jordan 12',
            slug: 'timeline/silhouettes/air-jordan-12',
            sort: 7,
            coverAsset: {
              id: 3580902,
              url: 'https://cms-cdn-staging.foodsworth.com/fda67ba46c7e-7389-ae11-789e-03ed0980.jpeg',
              aspect: 1.68067226890756,
              imageFileName: 'AJ12.jpeg',
              type: 'picture',
              thumbUrl:
                'https://cms-cdn-staging.foodsworth.com/375/fda67ba46c7e-7389-ae11-789e-03ed0980.jpeg',
              smallUrl:
                'https://cms-cdn-staging.foodsworth.com/750/fda67ba46c7e-7389-ae11-789e-03ed0980.jpeg',
              mediumUrl:
                'https://cms-cdn-staging.foodsworth.com/1500/fda67ba46c7e-7389-ae11-789e-03ed0980.jpeg',
              largeUrl:
                'https://cms-cdn-staging.foodsworth.com/3000/fda67ba46c7e-7389-ae11-789e-03ed0980.jpeg',
            },
          },
        ],
      },
    ],
    years: {
      name: 'Years',
      slug: 'timeline/years',
      sort: 3,
      children: [
        {
          name: '2016',
          slug: 'timeline/years/2016',
          sort: 1,
          description:
            '<p>A full year of releases, including the adidas Futurecraft 3D, Rihanna Puma collection, UltraBoost, NMD and Nike HyperAdapt 1.0</p>',
        },
        {
          name: '2017',
          slug: 'timeline/years/2017',
          sort: 2,
          description:
            "<p>Chicago natives dominated 2017, with Kanye launching the Waverunner 700 and Virgil working on the Off-White x Nike 'The Ten'&nbsp;</p>",
        },
        {
          name: '2018',
          slug: 'timeline/years/2018',
          sort: 3,
          description:
            '<p>Lifestyle collabs and Yeezy dominate, with the Sean Wotherspoon Air Max 1/97, Travis Scott x AJ4 and Fear Of God releasing</p>',
        },
        {
          name: '2019',
          slug: 'timeline/years/2019',
          sort: 4,
          description:
            '<p>2019 continues the trend of style overtaking performance. Top styles include adidas Yeezys and the 30th anniversary of the AJ4</p>',
        },
        {
          name: '2020',
          slug: 'timeline/years/2020',
          sort: 5,
          description:
            '<p>Lifestyle collabs continue, led by the Dior x AJ1 and Union x AJ4. Yeezy and Kobe both see great styles and colors release</p>',
        },
        {
          name: '2015',
          slug: 'timeline/years/2015',
          sort: 6,
          description:
            "<p>adidas dominates with the UltraBoost, NMD and Yeezy 350. Nike launched the AJ11 '72-10' as well as the Drake Air Jordan 10 x OVO</p>",
        },
        {
          name: '2014',
          slug: 'timeline/years/2014',
          sort: 7,
          description:
            '<p>Rick Owens and Raf Simons work with adidas, while Fragment Design and Jordan Brand link up on an Air Jordan 1 Retro</p>',
        },
        {
          name: '2013',
          slug: 'timeline/years/2013',
          sort: 8,
          description:
            '<p>The Air Jordan 1 returns in several new and original colors, including the Chicago, Bred, Black Toe, Royal and more</p>',
        },
        {
          name: '2012',
          slug: 'timeline/years/2012',
          sort: 9,
          description:
            "<p>The 'Galaxy' Foamposite causes riots during Orlando All-Star Weekend, while Nike unveils Flyknit technology at the Summer Olympics</p>",
        },
        {
          name: '2011',
          slug: 'timeline/years/2011',
          sort: 10,
          description:
            "<p>Back from the Future, the Nike Mag sees a limited release for charity. Ronnie Fieg works with ASICS on the 'Salmon Toe' Gel Lyte 3</p>",
        },
        {
          name: '2010',
          slug: 'timeline/years/2010',
          sort: 11,
          description:
            "<p>A pair of Nike Basketball shoes headline 2010, with the LeBron 8 'South Beach' and Kobe 6 'Grinch' both using bright vivid colors</p>",
        },
        {
          name: '2009',
          slug: 'timeline/years/2009',
          sort: 12,
          description:
            '<p>Kanye West debuted the Nike Air Yeezy, the first non-athlete signature shoe. The Kobe 4 turned heads as a true low-top hoops shoe</p>',
        },
        {
          name: '2008',
          slug: 'timeline/years/2008',
          sort: 13,
          description:
            '<p>Nike unveils Flywire at the Beijing Olympics, highlighted by the new lightweight basketball shoe, the Nike Hyperdunk</p>',
        },
        {
          name: '2007',
          slug: 'timeline/years/2007',
          sort: 14,
          description:
            "<p>ASICS starts working with Ronnie Fieg, releasing the Fieg 252 pack. Nike SB unveils the 'What The' concept on the Dunk Low SB</p>",
        },
        {
          name: '2006',
          slug: 'timeline/years/2006',
          sort: 15,
          description:
            "<p>Japanese brand A Bathing Ape's Bapesta sees mainstream success, while Kobe launches his first Nike signature shoe, the Zoom Kobe 1</p>",
        },
        {
          name: '2005',
          slug: 'timeline/years/2005',
          sort: 16,
          description: '',
        },
        {
          name: '2004',
          slug: 'timeline/years/2004',
          sort: 17,
        },
        {
          name: '2003',
          slug: 'timeline/years/2003',
          sort: 18,
        },
        {
          name: '2002',
          slug: 'timeline/years/2002',
          sort: 19,
        },
        {
          name: '2001',
          slug: 'timeline/years/2001',
          sort: 20,
        },
        {
          name: '2000',
          slug: 'timeline/years/2000',
          sort: 21,
        },
        {
          name: '1999',
          slug: 'timeline/years/1999',
          sort: 22,
        },
        {
          name: '1998',
          slug: 'timeline/years/1998',
          sort: 23,
        },
        {
          name: '1997',
          slug: 'timeline/years/1997',
          sort: 24,
        },
        {
          name: '1996',
          slug: 'timeline/years/1996',
          sort: 25,
        },
        {
          name: '1995',
          slug: 'timeline/years/1995',
          sort: 26,
        },
        {
          name: '1994',
          slug: 'timeline/years/1994',
          sort: 27,
        },
        {
          name: '1991',
          slug: 'timeline/years/1991',
          sort: 28,
        },
        {
          name: '1993',
          slug: 'timeline/years/1993',
          sort: 29,
        },
        {
          name: '1992',
          slug: 'timeline/years/1992',
          sort: 30,
        },
        {
          name: '1990',
          slug: 'timeline/years/1990',
          sort: 31,
        },
        {
          name: '1989',
          slug: 'timeline/years/1989',
          sort: 32,
        },
        {
          name: '1988',
          slug: 'timeline/years/1988',
          sort: 33,
        },
        {
          name: '1987',
          slug: 'timeline/years/1987',
          sort: 34,
        },
        {
          name: '1986',
          slug: 'timeline/years/1986',
          sort: 35,
        },
        {
          name: '1985',
          slug: 'timeline/years/1985',
          sort: 36,
        },
      ],
    },
    silhouettes: {
      name: 'Silhouettes',
      slug: 'timeline/silhouettes',
      sort: 4,
      children: [
        {
          name: 'Air Force 1',
          slug: 'timeline/silhouettes/air-force-1',
          sort: 1,
          coverAsset: {
            id: 3580872,
            url: 'https://cms-cdn-staging.foodsworth.com/fda67ba46c7e-7389-ae11-689e-030c4d24.jpeg',
            aspect: 2.10084033613445,
            imageFileName: 'AF1.jpeg',
            type: 'picture',
            thumbUrl:
              'https://cms-cdn-staging.foodsworth.com/375/fda67ba46c7e-7389-ae11-689e-030c4d24.jpeg',
            smallUrl:
              'https://cms-cdn-staging.foodsworth.com/750/fda67ba46c7e-7389-ae11-689e-030c4d24.jpeg',
            mediumUrl:
              'https://cms-cdn-staging.foodsworth.com/1500/fda67ba46c7e-7389-ae11-689e-030c4d24.jpeg',
            largeUrl:
              'https://cms-cdn-staging.foodsworth.com/3000/fda67ba46c7e-7389-ae11-689e-030c4d24.jpeg',
          },
        },
        {
          name: 'Air Jordan 1',
          slug: 'timeline/silhouettes/air-jordan-1',
          sort: 2,
          coverAsset: {
            id: 3580900,
            url: 'https://cms-cdn-staging.foodsworth.com/fda67ba46c7e-7389-ae11-789e-0ce9d680.jpeg',
            aspect: 1.61812297734628,
            imageFileName: 'AJ1.jpeg',
            type: 'picture',
            thumbUrl:
              'https://cms-cdn-staging.foodsworth.com/375/fda67ba46c7e-7389-ae11-789e-0ce9d680.jpeg',
            smallUrl:
              'https://cms-cdn-staging.foodsworth.com/750/fda67ba46c7e-7389-ae11-789e-0ce9d680.jpeg',
            mediumUrl:
              'https://cms-cdn-staging.foodsworth.com/1500/fda67ba46c7e-7389-ae11-789e-0ce9d680.jpeg',
            largeUrl:
              'https://cms-cdn-staging.foodsworth.com/3000/fda67ba46c7e-7389-ae11-789e-0ce9d680.jpeg',
          },
        },
        {
          name: 'Air Jordan 3',
          slug: 'timeline/silhouettes/air-jordan-3',
          sort: 3,
          coverAsset: {
            id: 3580901,
            url: 'https://cms-cdn-staging.foodsworth.com/fda67ba46c7e-7389-ae11-789e-02cd5780.jpeg',
            aspect: 1.68918918918919,
            imageFileName: 'AJ3.jpeg',
            type: 'picture',
            thumbUrl:
              'https://cms-cdn-staging.foodsworth.com/375/fda67ba46c7e-7389-ae11-789e-02cd5780.jpeg',
            smallUrl:
              'https://cms-cdn-staging.foodsworth.com/750/fda67ba46c7e-7389-ae11-789e-02cd5780.jpeg',
            mediumUrl:
              'https://cms-cdn-staging.foodsworth.com/1500/fda67ba46c7e-7389-ae11-789e-02cd5780.jpeg',
            largeUrl:
              'https://cms-cdn-staging.foodsworth.com/3000/fda67ba46c7e-7389-ae11-789e-02cd5780.jpeg',
          },
        },
        {
          name: 'Air Jordan 4',
          slug: 'timeline/silhouettes/air-jordan-4',
          sort: 4,
          coverAsset: {
            id: 3580898,
            url: 'https://cms-cdn-staging.foodsworth.com/fda67ba46c7e-7389-ae11-789e-0bd1c780.jpeg',
            aspect: 1.56739811912226,
            imageFileName: 'AJ4.jpeg',
            type: 'picture',
            thumbUrl:
              'https://cms-cdn-staging.foodsworth.com/375/fda67ba46c7e-7389-ae11-789e-0bd1c780.jpeg',
            smallUrl:
              'https://cms-cdn-staging.foodsworth.com/750/fda67ba46c7e-7389-ae11-789e-0bd1c780.jpeg',
            mediumUrl:
              'https://cms-cdn-staging.foodsworth.com/1500/fda67ba46c7e-7389-ae11-789e-0bd1c780.jpeg',
            largeUrl:
              'https://cms-cdn-staging.foodsworth.com/3000/fda67ba46c7e-7389-ae11-789e-0bd1c780.jpeg',
          },
        },
        {
          name: 'Air Jordan 5',
          slug: 'timeline/silhouettes/air-jordan-5',
          sort: 5,
          coverAsset: {
            id: 3580899,
            url: 'https://cms-cdn-staging.foodsworth.com/fda67ba46c7e-7389-ae11-789e-06da2880.jpeg',
            aspect: 1.49700598802395,
            imageFileName: 'AJ5.jpeg',
            type: 'picture',
            thumbUrl:
              'https://cms-cdn-staging.foodsworth.com/375/fda67ba46c7e-7389-ae11-789e-06da2880.jpeg',
            smallUrl:
              'https://cms-cdn-staging.foodsworth.com/750/fda67ba46c7e-7389-ae11-789e-06da2880.jpeg',
            mediumUrl:
              'https://cms-cdn-staging.foodsworth.com/1500/fda67ba46c7e-7389-ae11-789e-06da2880.jpeg',
            largeUrl:
              'https://cms-cdn-staging.foodsworth.com/3000/fda67ba46c7e-7389-ae11-789e-06da2880.jpeg',
          },
        },
        {
          name: 'Air Jordan 11',
          slug: 'timeline/silhouettes/air-jordan-11',
          sort: 6,
          coverAsset: {
            id: 3580897,
            url: 'https://cms-cdn-staging.foodsworth.com/fda67ba46c7e-7389-ae11-789e-0fd76880.jpeg',
            aspect: 1.78571428571429,
            imageFileName: 'AJ11.jpeg',
            type: 'picture',
            thumbUrl:
              'https://cms-cdn-staging.foodsworth.com/375/fda67ba46c7e-7389-ae11-789e-0fd76880.jpeg',
            smallUrl:
              'https://cms-cdn-staging.foodsworth.com/750/fda67ba46c7e-7389-ae11-789e-0fd76880.jpeg',
            mediumUrl:
              'https://cms-cdn-staging.foodsworth.com/1500/fda67ba46c7e-7389-ae11-789e-0fd76880.jpeg',
            largeUrl:
              'https://cms-cdn-staging.foodsworth.com/3000/fda67ba46c7e-7389-ae11-789e-0fd76880.jpeg',
          },
        },
        {
          name: 'Air Jordan 12',
          slug: 'timeline/silhouettes/air-jordan-12',
          sort: 7,
          coverAsset: {
            id: 3580902,
            url: 'https://cms-cdn-staging.foodsworth.com/fda67ba46c7e-7389-ae11-789e-03ed0980.jpeg',
            aspect: 1.68067226890756,
            imageFileName: 'AJ12.jpeg',
            type: 'picture',
            thumbUrl:
              'https://cms-cdn-staging.foodsworth.com/375/fda67ba46c7e-7389-ae11-789e-03ed0980.jpeg',
            smallUrl:
              'https://cms-cdn-staging.foodsworth.com/750/fda67ba46c7e-7389-ae11-789e-03ed0980.jpeg',
            mediumUrl:
              'https://cms-cdn-staging.foodsworth.com/1500/fda67ba46c7e-7389-ae11-789e-03ed0980.jpeg',
            largeUrl:
              'https://cms-cdn-staging.foodsworth.com/3000/fda67ba46c7e-7389-ae11-789e-03ed0980.jpeg',
          },
        },
      ],
    },
  },
  icon: {
    name: 'Icon',
    slug: 'icon',
    sort: 6,
    children: [
      {
        name: 'Genesis II',
        slug: 'icon/genesis-ii',
        sort: 1,
        description:
          '<p>MCQ, a revolutionary new label and platform powered by a creative collective from around the world, introduces Genesis II. Every item features blockchain and NFC technology, enabling people to trace the history of an item from where and when it was made to how many were produced. The future of fashion has arrived.</p>',
        metadataDescription:
          'MCQ, a revolutionary new label and platform powered by a creative collective from around the world, introduces Genesis II. Every item features blockchain and NFC technology, enabling people to trace the history of an item from where and when it was made to how many were produced. The future of fashion has arrived.',
        headerAsset: {
          id: 3616530,
          url: 'https://cms-cdn-staging.foodsworth.com/56340edd6cba-c8a9-ae11-e54f-0b2f4848.png',
          aspect: 1.88775510204082,
          imageFileName: 'Icon - Genesis 2.png',
          type: 'picture',
          thumbUrl:
            'https://cms-cdn-staging.foodsworth.com/375/56340edd6cba-c8a9-ae11-e54f-0b2f4848.png',
          smallUrl:
            'https://cms-cdn-staging.foodsworth.com/750/56340edd6cba-c8a9-ae11-e54f-0b2f4848.png',
          mediumUrl:
            'https://cms-cdn-staging.foodsworth.com/1500/56340edd6cba-c8a9-ae11-e54f-0b2f4848.png',
          largeUrl:
            'https://cms-cdn-staging.foodsworth.com/3000/56340edd6cba-c8a9-ae11-e54f-0b2f4848.png',
        },
      },
      {
        name: 'Arcade',
        slug: 'icon/arcade',
        sort: 2,
        description:
          '<p>MCQ, a revolutionary new label and platform powered by a creative collective from around the world, introduces Genesis II. Every item features blockchain and NFC technology, enabling people to trace the history of an item from where and when it was made to how many were produced. The future of fashion has arrived.</p>',
        headerAsset: {
          id: 3616942,
          url: 'https://cms-cdn-staging.foodsworth.com/56340edd6cba-c8a9-ae11-064f-05b464af.png',
          aspect: 3.12121212121212,
          imageFileName: 'Icon - Arcade.png',
          type: 'picture',
          thumbUrl:
            'https://cms-cdn-staging.foodsworth.com/375/56340edd6cba-c8a9-ae11-064f-05b464af.png',
          smallUrl:
            'https://cms-cdn-staging.foodsworth.com/750/56340edd6cba-c8a9-ae11-064f-05b464af.png',
          mediumUrl:
            'https://cms-cdn-staging.foodsworth.com/1500/56340edd6cba-c8a9-ae11-064f-05b464af.png',
          largeUrl:
            'https://cms-cdn-staging.foodsworth.com/3000/56340edd6cba-c8a9-ae11-064f-05b464af.png',
        },
      },
      {
        name: 'Foam',
        slug: 'icon/foam',
        sort: 3,
        description:
          "<p>On 27 July 2006, the company launched a lower-priced diffusion line McQ. The new line carries men's and women's ready-to-wear and accessories, was exclusively designed by Lee Alexander McQueen, manufactured and distributed worldwide by SINV SpA under the terms of a five-year licence agreement with Alexander McQueen. Promoted as a denim line, the focus of McQ is a youthful target market. The Spring/Summer 2011 was the final collection in collaboration with SINV SpA. Pina Ferlisi was appointed as the creative director for the line in June 2010.</p>",
        headerAsset: {
          id: 3616960,
          url: 'https://cms-cdn-staging.foodsworth.com/56340edd6cba-c8a9-ae11-164f-04f80089.png',
          aspect: 1.26241134751773,
          imageFileName: 'Icon - Foam.png',
          type: 'picture',
          thumbUrl:
            'https://cms-cdn-staging.foodsworth.com/375/56340edd6cba-c8a9-ae11-164f-04f80089.png',
          smallUrl:
            'https://cms-cdn-staging.foodsworth.com/750/56340edd6cba-c8a9-ae11-164f-04f80089.png',
          mediumUrl:
            'https://cms-cdn-staging.foodsworth.com/1500/56340edd6cba-c8a9-ae11-164f-04f80089.png',
          largeUrl:
            'https://cms-cdn-staging.foodsworth.com/3000/56340edd6cba-c8a9-ae11-164f-04f80089.png',
        },
      },
    ],
    'genesis-ii': {
      name: 'Genesis II',
      slug: 'icon/genesis-ii',
      sort: 1,
      description:
        '<p>MCQ, a revolutionary new label and platform powered by a creative collective from around the world, introduces Genesis II. Every item features blockchain and NFC technology, enabling people to trace the history of an item from where and when it was made to how many were produced. The future of fashion has arrived.</p>',
      metadataDescription:
        'MCQ, a revolutionary new label and platform powered by a creative collective from around the world, introduces Genesis II. Every item features blockchain and NFC technology, enabling people to trace the history of an item from where and when it was made to how many were produced. The future of fashion has arrived.',
      headerAsset: {
        id: 3616530,
        url: 'https://cms-cdn-staging.foodsworth.com/56340edd6cba-c8a9-ae11-e54f-0b2f4848.png',
        aspect: 1.88775510204082,
        imageFileName: 'Icon - Genesis 2.png',
        type: 'picture',
        thumbUrl:
          'https://cms-cdn-staging.foodsworth.com/375/56340edd6cba-c8a9-ae11-e54f-0b2f4848.png',
        smallUrl:
          'https://cms-cdn-staging.foodsworth.com/750/56340edd6cba-c8a9-ae11-e54f-0b2f4848.png',
        mediumUrl:
          'https://cms-cdn-staging.foodsworth.com/1500/56340edd6cba-c8a9-ae11-e54f-0b2f4848.png',
        largeUrl:
          'https://cms-cdn-staging.foodsworth.com/3000/56340edd6cba-c8a9-ae11-e54f-0b2f4848.png',
      },
    },
    arcade: {
      name: 'Arcade',
      slug: 'icon/arcade',
      sort: 2,
      description:
        '<p>MCQ, a revolutionary new label and platform powered by a creative collective from around the world, introduces Genesis II. Every item features blockchain and NFC technology, enabling people to trace the history of an item from where and when it was made to how many were produced. The future of fashion has arrived.</p>',
      headerAsset: {
        id: 3616942,
        url: 'https://cms-cdn-staging.foodsworth.com/56340edd6cba-c8a9-ae11-064f-05b464af.png',
        aspect: 3.12121212121212,
        imageFileName: 'Icon - Arcade.png',
        type: 'picture',
        thumbUrl:
          'https://cms-cdn-staging.foodsworth.com/375/56340edd6cba-c8a9-ae11-064f-05b464af.png',
        smallUrl:
          'https://cms-cdn-staging.foodsworth.com/750/56340edd6cba-c8a9-ae11-064f-05b464af.png',
        mediumUrl:
          'https://cms-cdn-staging.foodsworth.com/1500/56340edd6cba-c8a9-ae11-064f-05b464af.png',
        largeUrl:
          'https://cms-cdn-staging.foodsworth.com/3000/56340edd6cba-c8a9-ae11-064f-05b464af.png',
      },
    },
    foam: {
      name: 'Foam',
      slug: 'icon/foam',
      sort: 3,
      description:
        "<p>On 27 July 2006, the company launched a lower-priced diffusion line McQ. The new line carries men's and women's ready-to-wear and accessories, was exclusively designed by Lee Alexander McQueen, manufactured and distributed worldwide by SINV SpA under the terms of a five-year licence agreement with Alexander McQueen. Promoted as a denim line, the focus of McQ is a youthful target market. The Spring/Summer 2011 was the final collection in collaboration with SINV SpA. Pina Ferlisi was appointed as the creative director for the line in June 2010.</p>",
      headerAsset: {
        id: 3616960,
        url: 'https://cms-cdn-staging.foodsworth.com/56340edd6cba-c8a9-ae11-164f-04f80089.png',
        aspect: 1.26241134751773,
        imageFileName: 'Icon - Foam.png',
        type: 'picture',
        thumbUrl:
          'https://cms-cdn-staging.foodsworth.com/375/56340edd6cba-c8a9-ae11-164f-04f80089.png',
        smallUrl:
          'https://cms-cdn-staging.foodsworth.com/750/56340edd6cba-c8a9-ae11-164f-04f80089.png',
        mediumUrl:
          'https://cms-cdn-staging.foodsworth.com/1500/56340edd6cba-c8a9-ae11-164f-04f80089.png',
        largeUrl:
          'https://cms-cdn-staging.foodsworth.com/3000/56340edd6cba-c8a9-ae11-164f-04f80089.png',
      },
    },
  },
  test: {
    name: 'test a',
    slug: 'test',
    sort: 7,
    description: '',
    coverAsset: {
      id: 3605191,
      url: 'https://cms-cdn-staging.foodsworth.com/56340edd6cba-c8a9-ae11-b12f-072d59eb.png',
      aspect: 1.63076923076923,
      imageFileName: 'test shoe test',
      type: 'picture',
      thumbUrl:
        'https://cms-cdn-staging.foodsworth.com/375/56340edd6cba-c8a9-ae11-b12f-072d59eb.png',
      smallUrl:
        'https://cms-cdn-staging.foodsworth.com/750/56340edd6cba-c8a9-ae11-b12f-072d59eb.png',
      mediumUrl:
        'https://cms-cdn-staging.foodsworth.com/1500/56340edd6cba-c8a9-ae11-b12f-072d59eb.png',
      largeUrl:
        'https://cms-cdn-staging.foodsworth.com/3000/56340edd6cba-c8a9-ae11-b12f-072d59eb.png',
    },
    headerAsset: {
      id: 3597875,
      url: 'https://cms-cdn-staging.foodsworth.com/56340edd6cba-c8a9-ae11-13ee-0f1329c6.png',
      aspect: 1.83700440528634,
      imageFileName: 'jordan shoe test test',
      type: 'picture',
      thumbUrl:
        'https://cms-cdn-staging.foodsworth.com/375/56340edd6cba-c8a9-ae11-13ee-0f1329c6.png',
      smallUrl:
        'https://cms-cdn-staging.foodsworth.com/750/56340edd6cba-c8a9-ae11-13ee-0f1329c6.png',
      mediumUrl:
        'https://cms-cdn-staging.foodsworth.com/1500/56340edd6cba-c8a9-ae11-13ee-0f1329c6.png',
      largeUrl:
        'https://cms-cdn-staging.foodsworth.com/3000/56340edd6cba-c8a9-ae11-13ee-0f1329c6.png',
    },
  },
  navigation: {
    name: 'Navigation',
    slug: 'navigation',
    sort: 10,
    children: [
      {
        name: 'Featured Brands',
        slug: 'navigation/brand',
        sort: 1,
        children: [
          {
            name: 'Air Jordan',
            slug: 'brand/air-jordan',
            sort: 1,
          },
          {
            name: 'Alexander McQueen',
            slug: 'brand/alexander-mcqueen',
            sort: 2,
          },
          {
            name: 'Balenciaga',
            slug: 'brand/balenciaga',
            sort: 3,
          },
          {
            name: 'MCQ',
            slug: 'brand/mcq',
            sort: 4,
          },
          {
            name: 'Nike',
            slug: 'brand/nike',
            sort: 5,
          },
          {
            name: 'Off White',
            slug: 'brand/off-white',
            sort: 6,
          },
        ],
      },
      {
        name: 'Collections',
        slug: 'navigation/collections',
        sort: 2,
        children: [
          {
            name: 'Just Dropped',
            slug: 'collections/just-dropped',
            sort: 1,
          },
          {
            name: 'New In',
            slug: 'collections/new-arrivals-apparel',
            sort: 2,
          },
          {
            name: 'GOAT Selects',
            slug: 'collections/goat-selects',
            sort: 3,
          },
          {
            name: 'Most Wanted',
            slug: 'collections/most-wanted',
            sort: 4,
          },
        ],
      },
      {
        name: 'Categories',
        slug: 'navigation/category',
        sort: 3,
        children: [
          {
            name: 'Accessories',
            slug: 'accessories',
            sort: 1,
          },
          {
            name: 'Bags',
            slug: 'bags',
            sort: 2,
          },
          {
            name: 'Bottoms',
            slug: 'apparel/bottoms',
            sort: 3,
          },
          {
            name: 'Dresses',
            slug: 'apparel/dresses',
            sort: 4,
          },
          {
            name: 'Sneakers',
            slug: 'sneakers',
            sort: 5,
          },
          {
            name: 'Tops',
            slug: 'apparel/tops',
            sort: 6,
          },
        ],
      },
    ],
    brand: {
      name: 'Featured Brands',
      slug: 'navigation/brand',
      sort: 1,
      children: [
        {
          name: 'Air Jordan',
          slug: 'brand/air-jordan',
          sort: 1,
        },
        {
          name: 'Alexander McQueen',
          slug: 'brand/alexander-mcqueen',
          sort: 2,
        },
        {
          name: 'Balenciaga',
          slug: 'brand/balenciaga',
          sort: 3,
        },
        {
          name: 'MCQ',
          slug: 'brand/mcq',
          sort: 4,
        },
        {
          name: 'Nike',
          slug: 'brand/nike',
          sort: 5,
        },
        {
          name: 'Off White',
          slug: 'brand/off-white',
          sort: 6,
        },
      ],
    },
    collections: {
      name: 'Collections',
      slug: 'navigation/collections',
      sort: 2,
      children: [
        {
          name: 'Just Dropped',
          slug: 'collections/just-dropped',
          sort: 1,
        },
        {
          name: 'New In',
          slug: 'collections/new-arrivals-apparel',
          sort: 2,
        },
        {
          name: 'GOAT Selects',
          slug: 'collections/goat-selects',
          sort: 3,
        },
        {
          name: 'Most Wanted',
          slug: 'collections/most-wanted',
          sort: 4,
        },
      ],
    },
    category: {
      name: 'Categories',
      slug: 'navigation/category',
      sort: 3,
      children: [
        {
          name: 'Accessories',
          slug: 'accessories',
          sort: 1,
        },
        {
          name: 'Bags',
          slug: 'accessories/bags',
          sort: 2,
        },
        {
          name: 'Bottoms',
          slug: 'apparel/bottoms',
          sort: 3,
        },
        {
          name: 'Dresses',
          slug: 'apparel/dresses',
          sort: 4,
        },
        {
          name: 'Sneakers',
          slug: 'sneakers',
          sort: 5,
        },
        {
          name: 'Tops',
          slug: 'apparel/tops',
          sort: 6,
        },
      ],
    },
  },
  taxonomy: {
    name: 'Taxonomy',
    slug: 'taxonomy',
    children: [
      {
        name: 'Bags',
        slug: 'taxonomy/bags',
        children: [
          {
            name: 'Bags',
            slug: 'taxonomy/bags/bags',
          },
          {
            name: 'Tote Bags',
            slug: 'taxonomy/bags/tote_bags',
          },
          {
            name: 'Messengers And Satchels',
            slug: 'taxonomy/bags/messengers_and_satchels',
          },
          {
            name: 'Top Handle',
            slug: 'taxonomy/bags/top_handle',
          },
          {
            name: 'Duffles',
            slug: 'taxonomy/bags/duffles',
          },
          {
            name: 'Luggage',
            slug: 'taxonomy/bags/luggage',
          },
          {
            name: 'Travel Bags',
            slug: 'taxonomy/bags/travel_bags',
          },
          {
            name: 'Shoulder Bags',
            slug: 'taxonomy/bags/shoulder_bags',
          },
          {
            name: 'Pouches',
            slug: 'taxonomy/bags/pouches',
          },
          {
            name: 'Clutches',
            slug: 'taxonomy/bags/clutches',
          },
          {
            name: 'Briefcases',
            slug: 'taxonomy/bags/briefcases',
          },
          {
            name: 'Backpacks',
            slug: 'taxonomy/bags/backpacks',
          },
        ],
      },
      {
        name: 'Accessories',
        slug: 'taxonomy/accessories',
        children: [
          {
            name: 'Miscellaneous',
            slug: 'taxonomy/accessories/miscellaneous',
          },
          {
            name: 'Phone Cases',
            slug: 'taxonomy/accessories/phone_cases',
          },
          {
            name: 'Gloves',
            slug: 'taxonomy/accessories/gloves',
          },
          {
            name: 'Jewelry',
            slug: 'taxonomy/accessories/jewelry',
            children: [
              {
                name: 'Necklaces',
                slug: 'taxonomy/accessories/jewelry/necklaces',
              },
              {
                name: 'Rings',
                slug: 'taxonomy/accessories/jewelry/rings',
              },
              {
                name: 'Bracelets',
                slug: 'taxonomy/accessories/jewelry/bracelets',
              },
              {
                name: 'Earrings',
                slug: 'taxonomy/accessories/jewelry/earrings',
              },
              {
                name: 'Pins',
                slug: 'taxonomy/accessories/jewelry/pins',
              },
            ],
          },
          {
            name: 'Socks',
            slug: 'taxonomy/accessories/socks',
          },
          {
            name: 'Wallets',
            slug: 'taxonomy/accessories/wallets',
            children: [
              {
                name: 'Coin Pouches',
                slug: 'taxonomy/accessories/wallets/coin_pouches',
              },
              {
                name: 'Cardholders',
                slug: 'taxonomy/accessories/wallets/cardholders',
              },
            ],
          },
          {
            name: 'Hats',
            slug: 'taxonomy/accessories/hats',
            children: [
              {
                name: 'Caps',
                slug: 'taxonomy/accessories/hats/caps',
              },
              {
                name: 'Beanies',
                slug: 'taxonomy/accessories/hats/beanies',
              },
            ],
          },
          {
            name: 'Keychains',
            slug: 'taxonomy/accessories/keychains',
          },
          {
            name: 'Belts',
            slug: 'taxonomy/accessories/belts',
          },
          {
            name: 'Eyewear',
            slug: 'taxonomy/accessories/eyewear',
            children: [
              {
                name: 'Sunglasses',
                slug: 'taxonomy/accessories/eyewear/sunglasses',
              },
              {
                name: 'Goggles',
                slug: 'taxonomy/accessories/eyewear/goggles',
              },
            ],
          },
          {
            name: 'Scarves',
            slug: 'taxonomy/accessories/scarves',
          },
          {
            name: 'Umbrellas',
            slug: 'taxonomy/accessories/umbrellas',
          },
          {
            name: 'Watches',
            slug: 'taxonomy/accessories/watches',
          },
        ],
      },
      {
        name: 'Clothing',
        slug: 'taxonomy/clothing',
        children: [
          {
            name: 'Dresses',
            slug: 'taxonomy/clothing/dresses',
            children: [
              {
                name: 'Long',
                slug: 'taxonomy/clothing/dresses/long',
              },
              {
                name: 'Mid Length',
                slug: 'taxonomy/clothing/dresses/mid_length',
              },
              {
                name: 'Short',
                slug: 'taxonomy/clothing/dresses/short',
              },
            ],
          },
          {
            name: 'Outerwear',
            slug: 'taxonomy/clothing/outerwear',
            children: [
              {
                name: 'Parkas',
                slug: 'taxonomy/clothing/outerwear/parkas',
              },
              {
                name: 'Leather Jackets',
                slug: 'taxonomy/clothing/outerwear/leather-jackets',
              },
              {
                name: 'Denim Jackets',
                slug: 'taxonomy/clothing/outerwear/denim-jackets',
              },
              {
                name: 'Coats',
                slug: 'taxonomy/clothing/outerwear/coats',
              },
              {
                name: 'Jackets',
                slug: 'taxonomy/clothing/outerwear/jackets',
              },
              {
                name: 'Capes',
                slug: 'taxonomy/clothing/outerwear/capes',
              },
              {
                name: 'Down',
                slug: 'taxonomy/clothing/outerwear/down',
              },
              {
                name: 'Blazers',
                slug: 'taxonomy/clothing/outerwear/blazers',
              },
              {
                name: 'Bombers',
                slug: 'taxonomy/clothing/outerwear/bombers',
              },
              {
                name: 'Trench Coats',
                slug: 'taxonomy/clothing/outerwear/trench-coats',
              },
              {
                name: 'Vests',
                slug: 'taxonomy/clothing/outerwear/vests',
              },
            ],
          },
          {
            name: 'Bottoms',
            slug: 'taxonomy/clothing/bottoms',
            children: [
              {
                name: 'Shorts',
                slug: 'taxonomy/clothing/bottoms/shorts',
              },
              {
                name: 'Trousers',
                slug: 'taxonomy/clothing/bottoms/trousers',
              },
              {
                name: 'Skirts',
                slug: 'taxonomy/clothing/bottoms/skirts',
              },
              {
                name: 'Jeans',
                slug: 'taxonomy/clothing/bottoms/jeans',
              },
              {
                name: 'Sweatpants',
                slug: 'taxonomy/clothing/bottoms/sweatpants',
              },
              {
                name: 'Leggings',
                slug: 'taxonomy/clothing/bottoms/leggings',
              },
              {
                name: 'Jumpsuits',
                slug: 'taxonomy/clothing/bottoms/jumpsuits',
              },
            ],
          },
          {
            name: 'Tops',
            slug: 'taxonomy/clothing/tops',
            children: [
              {
                name: 'Knitwear',
                slug: 'taxonomy/clothing/tops/knitwear',
                children: [
                  {
                    name: 'Sweaters',
                    slug: 'taxonomy/clothing/tops/knitwear/sweaters',
                  },
                  {
                    name: 'Cardigans',
                    slug: 'taxonomy/clothing/tops/knitwear/cardigans',
                  },
                ],
              },
              {
                name: 'Shirts',
                slug: 'taxonomy/clothing/tops/shirts',
              },
              {
                name: 'T-Shirts',
                slug: 'taxonomy/clothing/tops/t-shirts',
                children: [
                  {
                    name: 'Long Sleeve T-Shirt',
                    slug: 'taxonomy/clothing/tops/t-shirts/long-sleeve-t-shirt',
                  },
                  {
                    name: 'Short Sleeve T-Shirt',
                    slug: 'taxonomy/clothing/tops/t-shirts/short-sleeve-t-shirt',
                  },
                ],
              },
              {
                name: 'Polos',
                slug: 'taxonomy/clothing/tops/polos',
              },
              {
                name: 'Jerseys',
                slug: 'taxonomy/clothing/tops/jerseys',
              },
              {
                name: 'Blouses',
                slug: 'taxonomy/clothing/tops/blouses',
              },
              {
                name: 'Tanks',
                slug: 'taxonomy/clothing/tops/tanks',
              },
              {
                name: 'Sports Bras',
                slug: 'taxonomy/clothing/tops/sports_bras',
              },
              {
                name: 'Sweatshirts',
                slug: 'taxonomy/clothing/tops/sweatshirts',
                children: [
                  {
                    name: 'Hoodies',
                    slug: 'taxonomy/clothing/tops/sweatshirts/hoodies',
                  },
                  {
                    name: 'Crewnecks',
                    slug: 'taxonomy/clothing/tops/sweatshirts/crewnecks',
                  },
                ],
              },
            ],
          },
          {
            name: 'Swimwear',
            slug: 'taxonomy/clothing/swimwear',
            children: [
              {
                name: 'Shorts',
                slug: 'taxonomy/clothing/swimwear/shorts',
              },
              {
                name: 'Bikinis',
                slug: 'taxonomy/clothing/swimwear/bikinis',
              },
              {
                name: 'One Piece',
                slug: 'taxonomy/clothing/swimwear/one_piece',
              },
            ],
          },
        ],
      },
      {
        name: 'Shoes',
        slug: 'taxonomy/shoes',
        children: [
          {
            name: 'Sandals',
            slug: 'taxonomy/shoes/sandals',
          },
          {
            name: 'Cleats',
            slug: 'taxonomy/shoes/cleats',
          },
          {
            name: 'Boots',
            slug: 'taxonomy/shoes/boots',
          },
          {
            name: 'Sneakers',
            slug: 'taxonomy/shoes/sneakers',
            children: [
              {
                name: 'Skateboarding',
                slug: 'taxonomy/shoes/sneakers/skateboarding',
              },
              {
                name: 'Running',
                slug: 'taxonomy/shoes/sneakers/running',
              },
              {
                name: 'Lifestyle',
                slug: 'taxonomy/shoes/sneakers/lifesyle',
              },
              {
                name: 'Basketball',
                slug: 'taxonomy/shoes/sneakers/basketball',
              },
            ],
          },
        ],
      },
      {
        name: 'Virtual',
        slug: 'taxonomy/virtual',
        children: [
          {
            name: 'Raffle Ticket',
            slug: 'taxonomy/virtual/raffle_ticket',
          },
        ],
      },
    ],
    bags: {
      name: 'Bags',
      slug: 'taxonomy/bags',
      children: [
        {
          name: 'Bags',
          slug: 'taxonomy/bags/bags',
        },
        {
          name: 'Tote Bags',
          slug: 'taxonomy/bags/tote_bags',
        },
        {
          name: 'Messengers And Satchels',
          slug: 'taxonomy/bags/messengers_and_satchels',
        },
        {
          name: 'Top Handle',
          slug: 'taxonomy/bags/top_handle',
        },
        {
          name: 'Duffles',
          slug: 'taxonomy/bags/duffles',
        },
        {
          name: 'Luggage',
          slug: 'taxonomy/bags/luggage',
        },
        {
          name: 'Travel Bags',
          slug: 'taxonomy/bags/travel_bags',
        },
        {
          name: 'Shoulder Bags',
          slug: 'taxonomy/bags/shoulder_bags',
        },
        {
          name: 'Pouches',
          slug: 'taxonomy/bags/pouches',
        },
        {
          name: 'Clutches',
          slug: 'taxonomy/bags/clutches',
        },
        {
          name: 'Briefcases',
          slug: 'taxonomy/bags/briefcases',
        },
        {
          name: 'Backpacks',
          slug: 'taxonomy/bags/backpacks',
        },
      ],
    },
    accessories: {
      name: 'Accessories',
      slug: 'taxonomy/accessories',
      children: [
        {
          name: 'Miscellaneous',
          slug: 'taxonomy/accessories/miscellaneous',
        },
        {
          name: 'Phone Cases',
          slug: 'taxonomy/accessories/phone_cases',
        },
        {
          name: 'Gloves',
          slug: 'taxonomy/accessories/gloves',
        },
        {
          name: 'Jewelry',
          slug: 'taxonomy/accessories/jewelry',
          children: [
            {
              name: 'Necklaces',
              slug: 'taxonomy/accessories/jewelry/necklaces',
            },
            {
              name: 'Rings',
              slug: 'taxonomy/accessories/jewelry/rings',
            },
            {
              name: 'Bracelets',
              slug: 'taxonomy/accessories/jewelry/bracelets',
            },
            {
              name: 'Earrings',
              slug: 'taxonomy/accessories/jewelry/earrings',
            },
            {
              name: 'Pins',
              slug: 'taxonomy/accessories/jewelry/pins',
            },
          ],
        },
        {
          name: 'Socks',
          slug: 'taxonomy/accessories/socks',
        },
        {
          name: 'Wallets',
          slug: 'taxonomy/accessories/wallets',
          children: [
            {
              name: 'Coin Pouches',
              slug: 'taxonomy/accessories/wallets/coin_pouches',
            },
            {
              name: 'Cardholders',
              slug: 'taxonomy/accessories/wallets/cardholders',
            },
          ],
        },
        {
          name: 'Hats',
          slug: 'taxonomy/accessories/hats',
          children: [
            {
              name: 'Caps',
              slug: 'taxonomy/accessories/hats/caps',
            },
            {
              name: 'Beanies',
              slug: 'taxonomy/accessories/hats/beanies',
            },
          ],
        },
        {
          name: 'Keychains',
          slug: 'taxonomy/accessories/keychains',
        },
        {
          name: 'Belts',
          slug: 'taxonomy/accessories/belts',
        },
        {
          name: 'Eyewear',
          slug: 'taxonomy/accessories/eyewear',
          children: [
            {
              name: 'Sunglasses',
              slug: 'taxonomy/accessories/eyewear/sunglasses',
            },
            {
              name: 'Goggles',
              slug: 'taxonomy/accessories/eyewear/goggles',
            },
          ],
        },
        {
          name: 'Scarves',
          slug: 'taxonomy/accessories/scarves',
        },
        {
          name: 'Umbrellas',
          slug: 'taxonomy/accessories/umbrellas',
        },
        {
          name: 'Watches',
          slug: 'taxonomy/accessories/watches',
        },
      ],
    },
    clothing: {
      name: 'Clothing',
      slug: 'taxonomy/clothing',
      children: [
        {
          name: 'Dresses',
          slug: 'taxonomy/clothing/dresses',
          children: [
            {
              name: 'Long',
              slug: 'taxonomy/clothing/dresses/long',
            },
            {
              name: 'Mid Length',
              slug: 'taxonomy/clothing/dresses/mid_length',
            },
            {
              name: 'Short',
              slug: 'taxonomy/clothing/dresses/short',
            },
          ],
        },
        {
          name: 'Outerwear',
          slug: 'taxonomy/clothing/outerwear',
          children: [
            {
              name: 'Parkas',
              slug: 'taxonomy/clothing/outerwear/parkas',
            },
            {
              name: 'Leather Jackets',
              slug: 'taxonomy/clothing/outerwear/leather-jackets',
            },
            {
              name: 'Denim Jackets',
              slug: 'taxonomy/clothing/outerwear/denim-jackets',
            },
            {
              name: 'Coats',
              slug: 'taxonomy/clothing/outerwear/coats',
            },
            {
              name: 'Jackets',
              slug: 'taxonomy/clothing/outerwear/jackets',
            },
            {
              name: 'Capes',
              slug: 'taxonomy/clothing/outerwear/capes',
            },
            {
              name: 'Down',
              slug: 'taxonomy/clothing/outerwear/down',
            },
            {
              name: 'Blazers',
              slug: 'taxonomy/clothing/outerwear/blazers',
            },
            {
              name: 'Bombers',
              slug: 'taxonomy/clothing/outerwear/bombers',
            },
            {
              name: 'Trench Coats',
              slug: 'taxonomy/clothing/outerwear/trench-coats',
            },
            {
              name: 'Vests',
              slug: 'taxonomy/clothing/outerwear/vests',
            },
          ],
        },
        {
          name: 'Bottoms',
          slug: 'taxonomy/clothing/bottoms',
          children: [
            {
              name: 'Shorts',
              slug: 'taxonomy/clothing/bottoms/shorts',
            },
            {
              name: 'Trousers',
              slug: 'taxonomy/clothing/bottoms/trousers',
            },
            {
              name: 'Skirts',
              slug: 'taxonomy/clothing/bottoms/skirts',
            },
            {
              name: 'Jeans',
              slug: 'taxonomy/clothing/bottoms/jeans',
            },
            {
              name: 'Sweatpants',
              slug: 'taxonomy/clothing/bottoms/sweatpants',
            },
            {
              name: 'Leggings',
              slug: 'taxonomy/clothing/bottoms/leggings',
            },
            {
              name: 'Jumpsuits',
              slug: 'taxonomy/clothing/bottoms/jumpsuits',
            },
          ],
        },
        {
          name: 'Tops',
          slug: 'taxonomy/clothing/tops',
          children: [
            {
              name: 'Knitwear',
              slug: 'taxonomy/clothing/tops/knitwear',
              children: [
                {
                  name: 'Sweaters',
                  slug: 'taxonomy/clothing/tops/knitwear/sweaters',
                },
                {
                  name: 'Cardigans',
                  slug: 'taxonomy/clothing/tops/knitwear/cardigans',
                },
              ],
            },
            {
              name: 'Shirts',
              slug: 'taxonomy/clothing/tops/shirts',
            },
            {
              name: 'T-Shirts',
              slug: 'taxonomy/clothing/tops/t-shirts',
              children: [
                {
                  name: 'Long Sleeve T-Shirt',
                  slug: 'taxonomy/clothing/tops/t-shirts/long-sleeve-t-shirt',
                },
                {
                  name: 'Short Sleeve T-Shirt',
                  slug: 'taxonomy/clothing/tops/t-shirts/short-sleeve-t-shirt',
                },
              ],
            },
            {
              name: 'Polos',
              slug: 'taxonomy/clothing/tops/polos',
            },
            {
              name: 'Jerseys',
              slug: 'taxonomy/clothing/tops/jerseys',
            },
            {
              name: 'Blouses',
              slug: 'taxonomy/clothing/tops/blouses',
            },
            {
              name: 'Tanks',
              slug: 'taxonomy/clothing/tops/tanks',
            },
            {
              name: 'Sports Bras',
              slug: 'taxonomy/clothing/tops/sports_bras',
            },
            {
              name: 'Sweatshirts',
              slug: 'taxonomy/clothing/tops/sweatshirts',
              children: [
                {
                  name: 'Hoodies',
                  slug: 'taxonomy/clothing/tops/sweatshirts/hoodies',
                },
                {
                  name: 'Crewnecks',
                  slug: 'taxonomy/clothing/tops/sweatshirts/crewnecks',
                },
              ],
            },
          ],
        },
        {
          name: 'Swimwear',
          slug: 'taxonomy/clothing/swimwear',
          children: [
            {
              name: 'Shorts',
              slug: 'taxonomy/clothing/swimwear/shorts',
            },
            {
              name: 'Bikinis',
              slug: 'taxonomy/clothing/swimwear/bikinis',
            },
            {
              name: 'One Piece',
              slug: 'taxonomy/clothing/swimwear/one_piece',
            },
          ],
        },
      ],
    },
    shoes: {
      name: 'Shoes',
      slug: 'taxonomy/shoes',
      children: [
        {
          name: 'Sandals',
          slug: 'taxonomy/shoes/sandals',
        },
        {
          name: 'Cleats',
          slug: 'taxonomy/shoes/cleats',
        },
        {
          name: 'Boots',
          slug: 'taxonomy/shoes/boots',
        },
        {
          name: 'Sneakers',
          slug: 'taxonomy/shoes/sneakers',
          children: [
            {
              name: 'Skateboarding',
              slug: 'taxonomy/shoes/sneakers/skateboarding',
            },
            {
              name: 'Running',
              slug: 'taxonomy/shoes/sneakers/running',
            },
            {
              name: 'Lifestyle',
              slug: 'taxonomy/shoes/sneakers/lifesyle',
            },
            {
              name: 'Basketball',
              slug: 'taxonomy/shoes/sneakers/basketball',
            },
          ],
        },
      ],
    },
    virtual: {
      name: 'Virtual',
      slug: 'taxonomy/virtual',
      children: [
        {
          name: 'Raffle Ticket',
          slug: 'taxonomy/virtual/raffle_ticket',
        },
      ],
    },
  },
  calendar: {
    children: [
      {
        name: 'New Releases',
        slug: 'calendar/new',
        sort: 1,
        children: [
          {
            id: 694,
            name: "Wmns Dunk Low 'Photon Dust'",
            slug: 'mock-data-1',
            description: 'some description here',
            sort: 1,
          },
          {
            id: 695,
            name: "Wmns Dunk Low 'Barely Green'",
            slug: 'mock-data-2',
            sort: 2,
          },
          {
            id: 696,
            name: "Air Jordan 1 Retro High OG 'Shadow 2.0'",
            slug: 'mock-data-3',
            sort: 3,
          },
          {
            id: 697,
            name: "Yeezy 500 High 'Tactical Orange'",
            slug: 'mock-data-4',
            sort: 4,
          },
          {
            id: 698,
            name: "Yeezy 500 High 'Sumac'",
            slug: 'mock-data-5',
            sort: 5,
          },
          {
            id: 699,
            name: "Air Jordan 1 Retro High OG GS 'Shadow Something'",
            slug: 'mock-data-6',
            sort: 6,
          },
          {
            id: 700,
            name: "Dunk High SB 'TV Signal'",
            slug: 'mock-data-7',
            sort: 7,
          },
          {
            id: 701,
            name: "Air Jordan 5 Retro Low Wings 'Class of 2020'",
            slug: 'mock-data-8',
            sort: 8,
          },
        ],
      },
      {
        name: 'Upcoming Releases',
        slug: 'calendar/upcoming',
        sort: 1,
        children: [
          {
            id: 697,
            name: "Wmns Dunk High 'Photon Dust'",
            slug: 'mock-data-9',
            externalUrl: 'www.acne-studios.com',
            sort: 1,
          },
          {
            id: 698,
            name: "Wmns Dunk High 'Barely Green'",
            slug: 'mock-data-10',
            urlOverride: 'adidas-yeezy',
            sort: 2,
          },
          {
            id: 699,
            name: "Air Jordan 1 Retro Low OG 'Shadow 2.0'",
            slug: 'mock-data-11',
            urlOverride: 'adidas-yeezy',
            sort: 3,
          },
          {
            id: 700,
            name: "Yeezy 500 Low 'Tactical Orange'",
            slug: 'mock-data-12',
            urlOverride: 'adidas-yeezy',
            sort: 4,
          },
          {
            id: 701,
            name: "Yeezy 500 Low 'Sumac'",
            slug: 'mock-data-13',
            urlOverride: 'adidas-yeezy',
            sort: 5,
          },
          {
            id: 702,
            name: "Air Jordan 1 Retro Low OG GS 'Shadow Something'",
            slug: 'mock-data-14',
            urlOverride: 'adidas-yeezy',
            sort: 6,
          },
          {
            id: 703,
            name: "Dunk Low SB 'TV Signal'",
            slug: 'mock-data-15',
            urlOverride: 'adidas-yeezy',
            sort: 7,
          },
          {
            id: 704,
            name: "Air Jordan 5 Retro High Wings 'Class of 2020'",
            slug: 'mock-data-16',
            urlOverride: 'adidas-yeezy',
            sort: 8,
          },
        ],
      },
    ],
  },
};
